import {
  AppstoreAddOutlined,
  BellOutlined,
  CarOutlined,
  CarryOutOutlined,
  CiOutlined,
  CloseSquareOutlined,
  ClusterOutlined,
  DeliveredProcedureOutlined,
  DiffOutlined,
  ExportOutlined,
  FileDoneOutlined,
  HomeOutlined,
  ImportOutlined,
  LoginOutlined,
  PoundOutlined,
  RadiusSettingOutlined,
  RobotOutlined,
  SettingOutlined,
  ShopOutlined,
  ShoppingOutlined,
  SkinOutlined,
  ThunderboltOutlined,
} from "@ant-design/icons";
import { Link } from "react-router-dom";
import {
  ABSINTHIUM_REPORT_GENERATE_PERMISSION,
  ABSENTEEISM_INFORMED_REASON_REPORT_GENERATE_PERMISSION,
  ACCOUNT_CREATE_PERMISSION,
  ACCOUNT_DELETE_PERMISSION,
  ACCOUNT_EDIT_PERMISSION,
  ACCOUNT_VIEW_PERMISSION,
  AIR_HOLE_TYPE_CREATE_PERMISSION,
  AIR_HOLE_TYPE_DELETE_PERMISSION,
  AIR_HOLE_TYPE_EDIT_PERMISSION,
  AIR_HOLE_TYPE_VIEW_PERMISSION,
  AU_FORMULA_CREATE_PERMISSION,
  AU_FORMULA_DELETE_PERMISSION,
  AU_FORMULA_EDIT_PERMISSION,
  AU_FORMULA_VIEW_PERMISSION,
  ACTIVITY_LOG_VIEW_PERMISSION,
  APP_DASHBOARD_VIEW_PERMISSION,
  APP_OFFLINE_SYNC_LOG_VIEW_PERMISSION,
  ASSIGNMENT_CREATE_PERMISSION,
  ASSIGNMENT_DELETE_PERMISSION,
  ASSIGNMENT_EDIT_PERMISSION,
  ASSIGNMENT_VIEW_PERMISSION,
  B2BLC_CREATE_PERMISSION,
  B2BLC_DELETE_PERMISSION,
  B2BLC_EDIT_PERMISSION,
  B2BLC_VIEW_PERMISSION,
  B2B_LC_ACCEPTANCE_COMMISSION_CREATE_PERMISSION,
  B2B_LC_ACCEPTANCE_COMMISSION_DELETE_PERMISSION,
  B2B_LC_ACCEPTANCE_COMMISSION_EDIT_PERMISSION,
  B2B_LC_ACCEPTANCE_COMMISSION_VIEW_PERMISSION,
  B2B_LC_AMENDMENT_OPENING_COST_CREATE_PERMISSION,
  B2B_LC_AMENDMENT_OPENING_COST_DELETE_PERMISSION,
  B2B_LC_AMENDMENT_OPENING_COST_EDIT_PERMISSION,
  B2B_LC_AMENDMENT_OPENING_COST_VIEW_PERMISSION,
  B2B_LC_OPENING_COST_CREATE_PERMISSION,
  B2B_LC_OPENING_COST_DELETE_PERMISSION,
  B2B_LC_OPENING_COST_EDIT_PERMISSION,
  B2B_LC_OPENING_COST_VIEW_PERMISSION,
  B2B_LC_SHIPPING_GUARANTEE_COST_CREATE_PERMISSION,
  B2B_LC_SHIPPING_GUARANTEE_COST_DELETE_PERMISSION,
  B2B_LC_SHIPPING_GUARANTEE_COST_EDIT_PERMISSION,
  B2B_LC_SHIPPING_GUARANTEE_COST_VIEW_PERMISSION,
  BANK_CREATE_PERMISSION,
  BANK_DELETE_PERMISSION,
  BANK_EDIT_PERMISSION,
  BANK_VIEW_PERMISSION,
  BGMEA_UD_AMENDMENT_CREATE_PERMISSION,
  BGMEA_UD_AMENDMENT_DELETE_PERMISSION,
  BGMEA_UD_AMENDMENT_EDIT_PERMISSION,
  BGMEA_UD_AMENDMENT_VIEW_PERMISSION,
  BGMEA_UD_COST_CREATE_PERMISSION,
  BGMEA_UD_COST_DELETE_PERMISSION,
  BGMEA_UD_COST_EDIT_PERMISSION,
  BGMEA_UD_COST_VIEW_PERMISSION,
  BGMEA_UD_EXPORT_PERMISSION_COST_CREATE_PERMISSION,
  BGMEA_UD_EXPORT_PERMISSION_COST_DELETE_PERMISSION,
  BGMEA_UD_EXPORT_PERMISSION_COST_EDIT_PERMISSION,
  BGMEA_UD_EXPORT_PERMISSION_COST_VIEW_PERMISSION,
  BIN_CREATE_PERMISSION,
  BIN_DELETE_PERMISSION,
  BIN_EDIT_PERMISSION,
  BIN_VIEW_PERMISSION,
  BOLT_SEAL_LOG_CREATE_PERMISSION,
  BOLT_SEAL_LOG_DELETE_PERMISSION,
  BOLT_SEAL_LOG_EDIT_PERMISSION,
  BOLT_SEAL_LOG_REPORT_PERMISSION,
  BOLT_SEAL_LOG_VIEW_PERMISSION,
  BOM_CREATE_PERMISSION,
  BOM_DELETE_PERMISSION,
  BOM_EDIT_PERMISSION,
  BOM_EXPORT_PERMISSION,
  BOM_VIEW_PERMISSION,
  BOOKING_QTY_CREATE_PERMISSION,
  BOOKING_QTY_DELETE_PERMISSION,
  BOOKING_QTY_EDIT_PERMISSION,
  BOOKING_QTY_VIEW_PERMISSION,
  BRANCH_CREATE_PERMISSION,
  BRANCH_DELETE_PERMISSION,
  BRANCH_EDIT_PERMISSION,
  BRANCH_VIEW_PERMISSION,
  BUYER_CREATE_PERMISSION,
  BUYER_DELETE_PERMISSION,
  BUYER_EDIT_PERMISSION,
  BUYER_INQUIRY_CREATE_PERMISSION,
  BUYER_INQUIRY_DELETE_PERMISSION,
  BUYER_INQUIRY_EDIT_PERMISSION,
  BUYER_INQUIRY_VIEW_PERMISSION,
  BUYER_VIEW_PERMISSION,
  BUYER_WISE_CHECKLIST_VIEW_PERMISSION,
  BUYING_OFFICE_CREATE_PERMISSION,
  BUYING_OFFICE_DELETE_PERMISSION,
  BUYING_OFFICE_EDIT_PERMISSION,
  BUYING_OFFICE_VIEW_PERMISSION,
  CAPACITY_BOOKING_MENU_VIEW_PERMISSION,
  CAPACITY_BOOKING_VIEW_PERMISSION,
  CARTON_TYPE_CREATE_PERMISSION,
  CARTON_TYPE_DELETE_PERMISSION,
  CARTON_TYPE_EDIT_PERMISSION,
  CARTON_TYPE_VIEW_PERMISSION,
  CERTIFICATE_OF_ORIGIN_FEE_CREATE_PERMISSION,
  CERTIFICATE_OF_ORIGIN_FEE_DELETE_PERMISSION,
  CERTIFICATE_OF_ORIGIN_FEE_EDIT_PERMISSION,
  CERTIFICATE_OF_ORIGIN_FEE_VIEW_PERMISSION,
  CHALLAN_CREATE_PERMISSION,
  CHALLAN_DELETE_PERMISSION,
  CHALLAN_EDIT_PERMISSION,
  CHALLAN_VIEW_PERMISSION,
  CHECKLIST_MENU_VIEW_PERMISSION,
  COLOR_CREATE_PERMISSION,
  COLOR_DELETE_PERMISSION,
  COLOR_EDIT_PERMISSION,
  COLOR_VIEW_PERMISSION,
  COMMERCIAL_PACKING_REQUIREMENT_EDIT_PERMISSION,
  COMMERCIAL_PACKING_REQUIREMENT_VIEW_PERMISSION,
  COST_ESTIMATE_CREATE_PERMISSION,
  COST_ESTIMATE_DELETE_PERMISSION,
  COST_ESTIMATE_EDIT_PERMISSION,
  COST_ESTIMATE_VIEW_PERMISSION,
  COST_OF_MAKING_CREATE,
  COST_OF_MAKING_DELETE,
  COST_OF_MAKING_EDIT,
  COST_OF_MAKING_LIST,
  COST_SHEET_REPORT_DELETE_PERMISSION,
  COST_SHEET_REPORT_GENERATE_PERMISSION,
  COST_SHEET_REPORT_VIEW_PERMISSION,
  CUTTING_CREATE_PERMISSION,
  CUTTING_DELETE_PERMISSION,
  CUTTING_EDIT_PERMISSION,
  CUTTING_VIEW_PERMISSION,
  DAILY_IMPORT_POSITION_CREATE_PERMISSION,
  DAILY_IMPORT_POSITION_DELETE_PERMISSION,
  DAILY_IMPORT_POSITION_EDIT_PERMISSION,
  DAILY_IMPORT_POSITION_VIEW_PERMISSION,
  DAILY_LINE_PLAN_VIEW_PERMISSION,
  DAILY_LINE_TARGET_CREATE_PERMISSION,
  DAILY_LINE_TARGET_DELETE_PERMISSION,
  DAILY_LINE_TARGET_EDIT_PERMISSION,
  DAILY_LINE_TARGET_VIEW_PERMISSION,
  DAILY_SEWING_PERFORMANCE_VIEW_PERMISSION,
  DELETE_MRR_REPORT_VIEW_PERMISSION,
  DIGITALIZATION_ABSENTEEISM_VIEW_PERMISSION,
  DIGITALIZATION_DEFECT_VIEW_PERMISSION,
  DIGITALIZATION_MENU_VIEW_PERMISSION,
  DIGITALIZATION_SETTINGS_VIEW_PERMISSION,
  DRIVER_VEHICLE_INFO_CREATE_PERMISSION,
  DRIVER_VEHICLE_INFO_DELETE_PERMISSION,
  DRIVER_VEHICLE_INFO_DISPATCH_TIME_PERMISSION,
  DRIVER_VEHICLE_INFO_EDIT_PERMISSION,
  DRIVER_VEHICLE_INFO_VIEW_PERMISSION,
  EMBROIDERY_PRINTING_SMOCKING_PINTUCK_VIEW_PERMISSION,
  EPB_ATTRIBUTE_CREATE_PERMISSION,
  // EPB Attribute permissions
  EPB_ATTRIBUTE_DELETE_PERMISSION,
  EPB_ATTRIBUTE_EDIT_PERMISSION,
  EPB_ATTRIBUTE_VIEW_PERMISSION,
  EPB_TYPE_CREATE_PERMISSION,
  // EPB Type permissions
  EPB_TYPE_DELETE_PERMISSION,
  EPB_TYPE_EDIT_PERMISSION,
  EPB_TYPE_VIEW_PERMISSION,
  ERP_USAGE_MODULE_VIEW_PERMISSION,
  EXIM_CONFIGURE_CREATE_PERMISSION,
  EXIM_CONFIGURE_DELETE_PERMISSION,
  EXIM_CONFIGURE_EDIT_PERMISSION,
  EXIM_CONFIGURE_VIEW_PERMISSION,
  EXTERNAL_CNF_BILLS_CREATE_PERMISSION,
  EXTERNAL_CNF_BILLS_DELETE_PERMISSION,
  EXTERNAL_CNF_BILLS_EDIT_PERMISSION,
  EXTERNAL_CNF_BILLS_VIEW_PERMISSION,
  EXPORT_DETAILS_CREATE_PERMISSION,
  EXPORT_DETAILS_DELETE_PERMISSION,
  EXPORT_DETAILS_EDIT_PERMISSION,
  EXPORT_DETAILS_VIEW_PERMISSION,
  EXPORT_DOC_FEE_CREATE_PERMISSION,
  EXPORT_DOC_FEE_DELETE_PERMISSION,
  EXPORT_DOC_FEE_EDIT_PERMISSION,
  EXPORT_DOC_FEE_VIEW_PERMISSION,
  FABRIC_ACCESSORIES_AUTO_RECONCILIATION_VIEW_PERMISSION,
  FABRIC_REPORT_DELETE_PERMISSION,
  FABRIC_REPORT_GENERATE_PERMISSION,
  FABRIC_REPORT_VIEW_PERMISSION,
  FINISHING_GARMENT_RECEIVED_CREATE_PERMISSION,
  FINISHING_GARMENT_RECEIVED_UPDATE_PERMISSION,
  FINISHING_GARMENT_RECEIVED_VIEW_PERMISSION,
  FINISHING_LINE_CREATE_PERMISSION,
  FINISHING_LINE_DELETE_PERMISSION,
  FINISHING_LINE_EDIT_PERMISSION,
  FINISHING_LINE_MAPPING_CREATE_PERMISSION,
  FINISHING_LINE_MAPPING_VIEW_PERMISSION,
  FINISHING_LINE_VIEW_PERMISSION,
  FINISH_GARMENT_CREATE_PERMISSION,
  FINISH_GARMENT_DELETE_PERMISSION,
  FINISH_GARMENT_EDIT_PERMISSION,
  FINISH_GARMENT_VIEW_PERMISSION,
  CARTON_INVENTORY_CREATE_PERMISSION,
  CARTON_INVENTORY_DELETE_PERMISSION,
  CARTON_INVENTORY_EDIT_PERMISSION,
  CARTON_INVENTORY_VIEW_PERMISSION,
  FOLDING_CREATE_PERMISSION,
  FOLDING_DELETE_PERMISSION,
  FOLDING_EDIT_PERMISSION,
  FOLDING_REQUIREMENT_CREATE_PERMISSION,
  FOLDING_REQUIREMENT_DELETE_PERMISSION,
  FOLDING_REQUIREMENT_EDIT_PERMISSION,
  FOLDING_REQUIREMENT_VIEW_PERMISSION,
  FOLDING_VIEW_PERMISSION,
  GARMENTS_PARTS_CREATE_PERMISSION,
  GARMENTS_PARTS_DELETE_PERMISSION,
  GARMENTS_PARTS_EDIT_PERMISSION,
  GARMENTS_PARTS_VIEW_PERMISSION,
  GARMENTS_TRACKING_VIEW_PERMISSION,
  GARMENT_CATEGORY_CREATE_PERMISSION,
  GARMENT_CATEGORY_DELETE_PERMISSION,
  GARMENT_CATEGORY_EDIT_PERMISSION,
  GARMENT_CATEGORY_VIEW_PERMISSION,
  GARMENT_RECEIVED_CREATE_PERMISSION,
  GARMENT_RECEIVED_UPDATE_PERMISSION,
  GARMENT_RECEIVED_VIEW_PERMISSION,
  GARMENT_TYPE_CREATE_PERMISSION,
  GARMENT_TYPE_DELETE_PERMISSION,
  GARMENT_TYPE_EDIT_PERMISSION,
  GARMENT_TYPE_VIEW_PERMISSION,
  GENERATE_MRR_REPORT_VIEW_PERMISSION,
  GUSSET_TYPE_CREATE_PERMISSION,
  GUSSET_TYPE_DELETE_PERMISSION,
  GUSSET_TYPE_EDIT_PERMISSION,
  GUSSET_TYPE_VIEW_PERMISSION,
  GOODS_DELIVERY_CREATE_PERMISSION,
  GOODS_DELIVERY_DELETE_PERMISSION,
  GOODS_DELIVERY_EDIT_PERMISSION,
  GOODS_DELIVERY_VIEW_PERMISSION,
  HOURLY_FOLD_CREATE_PERMISSION,
  HOURLY_FOLD_EDIT_PERMISSION,
  HOURLY_FOLD_VIEW_PERMISSION,
  HOURLY_IRON_CREATE_PERMISSION,
  HOURLY_IRON_EDIT_PERMISSION,
  HOURLY_IRON_VIEW_PERMISSION,
  HOURLY_OPERATION_TRACKING_VIEW_PERMISSION,
  HOURLY_POLY_CREATE_PERMISSION,
  HOURLY_POLY_EDIT_PERMISSION,
  HOURLY_POLY_VIEW_PERMISSION,
  HOURLY_PRODUCTION_VIEW_PERMISSION,
  HR_OT_EXPENSE_DATA_IMPORT_PERMISSION,
  IMPORT_ACCEPTANCE_DETAIL_CREATE_PERMISSION,
  IMPORT_ACCEPTANCE_DETAIL_DELETE_PERMISSION,
  IMPORT_ACCEPTANCE_DETAIL_EDIT_PERMISSION,
  IMPORT_ACCEPTANCE_DETAIL_VIEW_PERMISSION,
  IMPORT_BILL_RETIREMENT_CREATE_PERMISSION,
  IMPORT_BILL_RETIREMENT_DELETE_PERMISSION,
  IMPORT_BILL_RETIREMENT_EDIT_PERMISSION,
  IMPORT_BILL_RETIREMENT_VIEW_PERMISSION,
  IMPORT_EXPORT_EXPENSE_TRACKING_VIEW_PERMISSION,
  IMPORT_MENU_VIEW_PERMISSION,
  EXPORT_SHIPMENT_VIEW_PERMISSION,
  EXPORT_SHIPMENT_CREATE_PERMISSION,
  EXPORT_SHIPMENT_EDIT_PERMISSION,
  EXPORT_SHIPMENT_DELETE_PERMISSION,
  EXPORT_VEHICLE_ASSIGNMENT_VIEW_PERMISSION,
  EXPORT_VEHICLE_ASSIGNMENT_STORE_PERMISSION,
  EXPORT_VEHICLE_ASSIGNMENT_EDIT_PERMISSION,
  EXPORT_VEHICLE_ASSIGNMENT_DELETE_PERMISSION,
  LOCAL_OUTGOING_SHIPMENT_VIEW_PERMISSION,
  LOCAL_OUTGOING_SHIPMENT_CREATE_PERMISSION,
  LOCAL_OUTGOING_SHIPMENT_EDIT_PERMISSION,
  LOCAL_OUTGOING_SHIPMENT_DELETE_PERMISSION,
  LOCAL_INCOMING_SHIPMENT_VIEW_PERMISSION,
  LOCAL_INCOMING_SHIPMENT_CREATE_PERMISSION,
  LOCAL_INCOMING_SHIPMENT_EDIT_PERMISSION,
  LOCAL_INCOMING_SHIPMENT_DELETE_PERMISSION,
  IMPORT_VEHICLE_ASSIGNMENT_DELETE_PERMISSION,
  IMPORT_VEHICLE_ASSIGNMENT_EDIT_PERMISSION,
  IMPORT_VEHICLE_ASSIGNMENT_STORE_PERMISSION,
  IMPORT_VEHICLE_ASSIGNMENT_VIEW_PERMISSION,
  INITIAL_SAM_MENU_PERMISSION,
  INITIAL_SAM_STORE_PERMISSION,
  INQUIRY_REASONS_CREATE_PERMISSION,
  INQUIRY_REASONS_DELETE_PERMISSION,
  INQUIRY_REASONS_EDIT_PERMISSION,
  INQUIRY_REASONS_VIEW_PERMISSION,
  INQUIRY_REMARKS_CREATE_PERMISSION,
  INQUIRY_REMARKS_DELETE_PERMISSION,
  INQUIRY_REMARKS_EDIT_PERMISSION,
  INQUIRY_REMARKS_VIEW_PERMISSION,
  INVENTORY_CREATE_PERMISSION,
  INVENTORY_DELETE_PERMISSION,
  INVENTORY_DETAIL_REPORT_DELETE_PERMISSION,
  INVENTORY_DETAIL_REPORT_GENERATE_PERMISSION,
  INVENTORY_DETAIL_REPORT_VIEW_PERMISSION,
  INVENTORY_EDIT_PERMISSION,
  INVENTORY_MRR_REPORT_VIEW_PERMISSION,
  INVENTORY_VIEW_PERMISSION,
  IOU_CREATE_PERMISSION,
  IOU_DELETE_PERMISSION,
  IOU_DISBURSE_PERMISSION,
  IOU_EDIT_PERMISSION,
  IOU_EXPENDITURE_FOR_EXPORT,
  IOU_EXPENDITURE_FOR_IMPORT,
  IOU_ADJUSTMENT_IMPORT_VIEW_PERMISSION,
  IOU_ADJUSTMENT_IMPORT_CREATE_PERMISSION,
  IOU_ADJUSTMENT_IMPORT_EDIT_PERMISSION,
  IOU_ADJUSTMENT_IMPORT_DELETE_PERMISSION,
  IOU_ADJUSTMENT_IMPORT_APPROVE_PERMISSION,
  IOU_ADJUSTMENT_EXPORT_VIEW_PERMISSION,
  IOU_ADJUSTMENT_EXPORT_CREATE_PERMISSION,
  IOU_ADJUSTMENT_EXPORT_EDIT_PERMISSION,
  IOU_ADJUSTMENT_EXPORT_DELETE_PERMISSION,
  IOU_ADJUSTMENT_EXPORT_APPROVE_PERMISSION,
  IOU_ADJUSTMENT_GENERAL_VIEW_PERMISSION,
  IOU_ADJUSTMENT_GENERAL_CREATE_PERMISSION,
  IOU_ADJUSTMENT_GENERAL_EDIT_PERMISSION,
  IOU_ADJUSTMENT_GENERAL_DELETE_PERMISSION,
  IOU_ADJUSTMENT_GENERAL_APPROVE_PERMISSION,
  IOU_VIEW_PERMISSION,
  IPR_REPORT_VIEW_PERMISSION,
  ITEM_CATEGORY_CREATE_PERMISSION,
  ITEM_CATEGORY_DELETE_PERMISSION,
  ITEM_CATEGORY_EDIT_PERMISSION,
  ITEM_CATEGORY_VIEW_PERMISSION,
  ITEM_CREATE_PERMISSION,
  ITEM_DELETE_PERMISSION,
  ITEM_EDIT_PERMISSION,
  ITEM_OCR_UPLOAD_PERMISSION,
  ITEM_TYPES_CREATE_PERMISSION,
  ITEM_TYPES_DELETE_PERMISSION,
  ITEM_TYPES_EDIT_PERMISSION,
  ITEM_TYPES_VIEW_PERMISSION,
  ITEM_VIEW_PERMISSION,
  LEARNING_CURVE_CREATE_PERMISSION,
  LEARNING_CURVE_DELETE_PERMISSION,
  LEARNING_CURVE_EDIT_PERMISSION,
  LEARNING_CURVE_VIEW_PERMISSION,
  CGL_AUDIT_REPORT_LIST_VIEW_PERMISSION,
  LINE_WISE_CATEGORY_DEFECT_REPORT_VIEW_PERMISSION,
  SEWING_LINE_DEFECT_REPORT_VIEW_PERMISSION,
  SEWING_LINE_DEFECT_MONTHLY_REPORT_VIEW_PERMISSION,
  QC_VALIDATION_REPORT_VIEW_PERMISSION,
  LINE_WISE_SEWING_REPORT_VIEW_PERMISSION,
  LOCAL_PURCHASE_RECONCILIATION_CREATE_PERMISSION,
  LOCAL_PURCHASE_RECONCILIATION_DELETE_PERMISSION,
  LOCAL_PURCHASE_RECONCILIATION_EDIT_PERMISSION,
  LOCAL_PURCHASE_RECONCILIATION_VIEW_PERMISSION,
  MACHINE_ACTION_TYPE_VIEW_PERMISSION,
  MACHINE_BRAND_VIEW_PERMISSION,
  MACHINE_COMPANY_VIEW_PERMISSION,
  MACHINE_FAULT_TYPE_VIEW_PERMISSION,
  MACHINE_INFORMATION_DELETE_PERMISSION,
  MACHINE_INFORMATION_IMPORT_PERMISSION,
  MACHINE_INFORMATION_STORE_PERMISSION,
  MACHINE_INFORMATION_UPDATE_PERMISSION,
  MACHINE_INFORMATION_VIEW_PERMISSION,
  MACHINE_LINE_ATTENDANCE_MECHANIC_LIST_PERMISSION,
  MACHINE_LINE_ISSUES_VIEW_PERMISSION,
  MACHINE_LOCATION_VIEW_PERMISSION,
  MACHINE_MACHINE_LINE_VIEW_PERMISSION,
  MACHINE_MODEL_VIEW_PERMISSION,
  MACHINE_ORIGIN_COUNTRY_VIEW_PERMISSION,
  MARINA_COVER_NOTE_BILL_CREATE_PERMISSION,
  MARINA_COVER_NOTE_BILL_DELETE_PERMISSION,
  MARINA_COVER_NOTE_BILL_EDIT_PERMISSION,
  MARINA_COVER_NOTE_BILL_VIEW_PERMISSION,
  NOTIFICATION_SETTING_CREATE_PERMISSION,
  NOTIFICATION_SETTING_DELETE_PERMISSION,
  NOTIFICATION_SETTING_EDIT_PERMISSION,
  NOTIFICATION_SETTING_VIEW_PERMISSION,
  NOTIFICATION_SLUG_CREATE_PERMISSION,
  NOTIFICATION_SLUG_DELETE_PERMISSION,
  NOTIFICATION_SLUG_EDIT_PERMISSION,
  NOTIFICATION_SLUG_VIEW_PERMISSION,
  NOTING_ASSESSMENT_CREATE_PERMISSION,
  NOTING_ASSESSMENT_DELETE_PERMISSION,
  NOTING_ASSESSMENT_EDIT_PERMISSION,
  NOTING_ASSESSMENT_VIEW_PERMISSION,
  NO_PERMISSION_REQUIRED,
  OB_CREATE_PERMISSION,
  OB_DELETE_PERMISSION,
  OB_EDIT_PERMISSION,
  OB_MACHINE_CREATE_PERMISSION,
  OB_MACHINE_DELETE_PERMISSION,
  OB_MACHINE_EDIT_PERMISSION,
  OB_MACHINE_VIEW_PERMISSION,
  OB_SAM_DATA_BANK_CREATE_PERMISSION,
  OB_SAM_DATA_BANK_DELETE_PERMISSION,
  OB_SAM_DATA_BANK_EDIT_PERMISSION,
  OB_SAM_DATA_BANK_VIEW_PERMISSION,
  OB_SECTION_CREATE_PERMISSION,
  OB_SECTION_DELETE_PERMISSION,
  OB_SECTION_EDIT_PERMISSION,
  OB_SECTION_VIEW_PERMISSION,
  OB_TEMPLATE_CREATE_PERMISSION,
  OB_TEMPLATE_DELETE_PERMISSION,
  OB_TEMPLATE_EDIT_PERMISSION,
  OB_TEMPLATE_VIEW_PERMISSION,
  OB_VIEW_PERMISSION,
  ORGANIZATION_CREATE_PERMISSION,
  ORGANIZATION_DELETE_PERMISSION,
  ORGANIZATION_EDIT_PERMISSION,
  ORGANIZATION_VIEW_PERMISSION,
  OSR_REPORT_GENERATE_PERMISSION,
  OT_SIGNAL_SECTION_VIEW_PERMISSION,
  OT_SIGNAL_VIEW_PERMISSION,
  PACKING_CREATE_PERMISSION,
  PACKING_DELETE_PERMISSION,
  PACKING_EDIT_PERMISSION,
  PACKING_LINE_CREATE_PERMISSION,
  PACKING_LINE_DELETE_PERMISSION,
  PACKING_LINE_EDIT_PERMISSION,
  PACKING_LINE_VIEW_PERMISSION,
  PACKING_LIST_REPORT_VIEW_PERMISSION,
  PACKING_OPERATOR_MAPPING_CREATE_PERMISSION,
  PACKING_OPERATOR_MAPPING_DELETE_PERMISSION,
  PACKING_OPERATOR_MAPPING_EDIT_PERMISSION,
  PACKING_OPERATOR_MAPPING_VIEW_PERMISSION,
  DAILY_PACKING_ASSIGNMENT_VIEW_PERMISSION,
  DAILY_PACKING_ASSIGNMENT_CREATE_PERMISSION,
  DAILY_PACKING_ASSIGNMENT_EDIT_PERMISSION,
  DAILY_PACKING_ASSIGNMENT_DELETE_PERMISSION,
  PACKING_REPORT_TEMPLATE_DELETE_PERMISSION,
  PACKING_REPORT_TEMPLATE_STORE_PERMISSION,
  PACKING_REPORT_TEMPLATE_UPDATE_PERMISSION,
  PACKING_REPORT_TEMPLATE_VIEW_PERMISSION,
  PACKING_TABLE_CREATE_PERMISSION,
  PACKING_TABLE_DELETE_PERMISSION,
  PACKING_TABLE_EDIT_PERMISSION,
  PACKING_TABLE_VIEW_PERMISSION,
  PACKING_VIEW_PERMISSION,
  PERMISSION_CREATE_PERMISSION,
  PERMISSION_DELETE_PERMISSION,
  PERMISSION_EDIT_PERMISSION,
  PERMISSION_VIEW_PERMISSION,
  PI_CREATE_PERMISSION,
  PI_DELETE_PERMISSION,
  PI_EDIT_PERMISSION,
  PI_VIEW_PERMISSION,
  PLY_CREATE_PERMISSION,
  PLY_DELETE_PERMISSION,
  PLY_EDIT_PERMISSION,
  PLY_VIEW_PERMISSION,
  POLY_TYPE_CREATE_PERMISSION,
  POLY_TYPE_DELETE_PERMISSION,
  POLY_TYPE_EDIT_PERMISSION,
  POLY_TYPE_VIEW_PERMISSION,
  PLAN_CREATE_PERMISSION,
  PLAN_DASHBOARD_VIEW_PERMISSION,
  PNL_REPORT_VIEW_PERMISSION,
  POST_COSTING_REPORT_GENERATE_PERMISSION,
  PP_BUYER_INSPECTION_MENU_VIEW_PERMISSION,
  PP_EXCEPTION_CREATE_PERMISSION,
  PP_EXCEPTION_DELETE_PERMISSION,
  PP_EXCEPTION_EDIT_PERMISSION,
  PP_EXCEPTION_VIEW_PERMISSION,
  PP_HOLIDAY_CREATE_PERMISSION,
  PP_HOLIDAY_DELETE_PERMISSION,
  PP_HOLIDAY_EDIT_PERMISSION,
  PP_HOLIDAY_VIEW_PERMISSION,
  PP_PLANNING_REQUEST_CREATE_PERMISSION,
  PP_PLANNING_REQUEST_DELETE_PERMISSION,
  PP_PLANNING_REQUEST_EDIT_PERMISSION,
  PP_PLANNING_REQUEST_VIEW_PERMISSION,
  PP_WEEKEND_CREATE_PERMISSION,
  PP_WEEKEND_DELETE_PERMISSION,
  PP_WEEKEND_EDIT_PERMISSION,
  PP_WEEKEND_VIEW_PERMISSION,
  PROBLEM_REMEDY_LOG_VIEW_PERMISSION,
  PROBLEM_REMEDY_MAP_CREATE_PERMISSION,
  PROBLEM_REMEDY_MAP_DELETE_PERMISSION,
  PROBLEM_REMEDY_MAP_EDIT_PERMISSION,
  PROBLEM_REMEDY_MAP_VIEW_PERMISSION,
  PRODUCT_DETAIL_REPORT_DELETE_PERMISSION,
  PRODUCT_DETAIL_REPORT_GENERATE_PERMISSION,
  PRODUCT_TRACK_REPORT_DELETE_PERMISSION,
  PRODUCT_TRACK_REPORT_GENERATE_PERMISSION,
  PRODUCT_TRACK_REPORT_VIEW_PERMISSION,
  PURCHASE_ORDER_CREATE_PERMISSION,
  PURCHASE_ORDER_DELETE_PERMISSION,
  PURCHASE_ORDER_EDIT_PERMISSION,
  PURCHASE_ORDER_VIEW_PERMISSION,
  RACK_CREATE_PERMISSION,
  RACK_DELETE_PERMISSION,
  RACK_EDIT_PERMISSION,
  RACK_VIEW_PERMISSION,
  ROLE_CREATE_PERMISSION,
  ROLE_DELETE_PERMISSION,
  ROLE_EDIT_PERMISSION,
  ROLE_VIEW_PERMISSION,
  SALES_CONTRACT_360_VIEW_PERMISSION,
  SALES_CONTRACT_AMENDMENT_LIEN_COST_CREATE_PERMISSION,
  SALES_CONTRACT_AMENDMENT_LIEN_COST_DELETE_PERMISSION,
  SALES_CONTRACT_AMENDMENT_LIEN_COST_EDIT_PERMISSION,
  SALES_CONTRACT_AMENDMENT_LIEN_COST_VIEW_PERMISSION,
  SALES_CONTRACT_COMMERCIAL_CREATE_PERMISSION,
  SALES_CONTRACT_COMMERCIAL_DELETE_PERMISSION,
  SALES_CONTRACT_COMMERCIAL_EDIT_PERMISSION,
  SALES_CONTRACT_COMMERCIAL_VIEW_PERMISSION,
  SALES_CONTRACT_COSTING_REPORT,
  SALES_CONTRACT_CREATE_PERMISSION,
  SALES_CONTRACT_DELETE_PERMISSION,
  SALES_CONTRACT_EDIT_PERMISSION,
  SALES_CONTRACT_LIEN_COST_CREATE_PERMISSION,
  SALES_CONTRACT_LIEN_COST_DELETE_PERMISSION,
  SALES_CONTRACT_LIEN_COST_EDIT_PERMISSION,
  SALES_CONTRACT_LIEN_COST_VIEW_PERMISSION,
  EB_COLLECTION_CHARGE_VIEW_PERMISSION,
  EB_COLLECTION_CHARGE_CREATE_PERMISSION,
  EB_COLLECTION_CHARGE_EDIT_PERMISSION,
  EB_COLLECTION_CHARGE_DELETE_PERMISSION,
  EB_COLLECTION_CHARGE_PRINT_PERMISSION,
  SALES_CONTRACT_VIEW_PERMISSION,
  SEWING_CREATE_PERMISSION,
  SEWING_DELETE_PERMISSION,
  SEWING_EDIT_PERMISSION,
  SEWING_FOLDING_REPORT_GENERATE_PERMISSION,
  SEWING_LINE_CREATE_PERMISSION,
  SEWING_LINE_DELETE_PERMISSION,
  SEWING_LINE_EDIT_PERMISSION,
  SEWING_LINE_VIEW_PERMISSION,
  SEWING_VIEW_PERMISSION,
  STORE_REQUISITION_CREATE_PERMISSION,
  STORE_REQUISITION_DELETE_PERMISSION,
  STORE_REQUISITION_EDIT_PERMISSION,
  STORE_REQUISITION_VIEW_PERMISSION,
  SHIPMENT_HANDOVER_CREATE_PERMISSION,
  SHIPMENT_HANDOVER_DELETE_PERMISSION,
  SHIPMENT_HANDOVER_EDIT_PERMISSION,
  SHIPMENT_HANDOVER_VIEW_PERMISSION,
  SHIPPING_CREATE_PERMISSION,
  SHIPPING_DELETE_PERMISSION,
  SHIPPING_EDIT_PERMISSION,
  SHIPPING_VIEW_PERMISSION,
  SIZE_CREATE_PERMISSION,
  SIZE_DELETE_PERMISSION,
  SIZE_EDIT_PERMISSION,
  SIZE_VIEW_PERMISSION,
  STOCK_LOT_CREATE_PERMISSION,
  STOCK_LOT_DELETE_PERMISSION,
  STOCK_LOT_EDIT_PERMISSION,
  STOCK_LOT_VIEW_PERMISSION,
  STYLE_CREATE_PERMISSION,
  STYLE_DELETE_PERMISSION,
  STYLE_EDIT_PERMISSION,
  STYLE_VIEW_PERMISSION,
  SUBCONTRACT_FACTORY_VIEW_PERMISSION,
  SUBMISSION_REALIZATION_CREATE_PERMISSION,
  SUBMISSION_REALIZATION_DELETE_PERMISSION,
  SUBMISSION_REALIZATION_EDIT_PERMISSION,
  SUBMISSION_REALIZATION_VIEW_PERMISSION,
  SUPPORTING_MATERIAL_TYPE_CREATE_PERMISSION,
  SUPPORTING_MATERIAL_TYPE_DELETE_PERMISSION,
  SUPPORTING_MATERIAL_TYPE_EDIT_PERMISSION,
  SUPPORTING_MATERIAL_TYPE_VIEW_PERMISSION,
  SUPERVISOR_CHECKLIST_CREATE_PERMISSION,
  SUPERVISOR_CHECKLIST_DELETE_PERMISSION,
  SUPERVISOR_CHECKLIST_EDIT_PERMISSION,
  SUPERVISOR_CHECKLIST_VIEW_PERMISSION,
  SUPPLIER_CREATE_PERMISSION,
  SUPPLIER_DELETE_PERMISSION,
  SUPPLIER_EDIT_PERMISSION,
  SUPPLIER_VIEW_PERMISSION,
  SUPPLIER_WISE_ITEM_PRICE_REPORT_VIEW_PERMISSION,
  PI_REPORT_VIEW_PERMISSION,
  TNA_DEPARTMENT_CREATE_PERMISSION,
  TNA_DEPARTMENT_DELETE_PERMISSION,
  TNA_DEPARTMENT_EDIT_PERMISSION,
  TNA_DEPARTMENT_VIEW_PERMISSION,
  TNA_PLAN_CREATE_PERMISSION,
  TNA_PLAN_DELETE_PERMISSION,
  TNA_PLAN_EDIT_PERMISSION,
  TNA_PLAN_VIEW_PERMISSION,
  TNA_PROCESS_CREATE_PERMISSION,
  TNA_PROCESS_DELETE_PERMISSION,
  TNA_PROCESS_EDIT_PERMISSION,
  TNA_PROCESS_VIEW_PERMISSION,
  TNA_SUMMARY_VIEW_PERMISSION,
  TNA_TASK_CREATE_PERMISSION,
  TNA_TASK_DELETE_PERMISSION,
  TNA_TASK_EDIT_PERMISSION,
  TNA_TASK_VIEW_PERMISSION,
  TNA_TEMPLATE_CREATE_PERMISSION,
  TNA_TEMPLATE_DELETE_PERMISSION,
  TNA_TEMPLATE_EDIT_PERMISSION,
  TNA_TEMPLATE_VIEW_PERMISSION,
  TNA_BY_STYLE_CREATE_PERMISSION,
  TNA_BY_STYLE_DELETE_PERMISSION,
  TNA_BY_STYLE_EDIT_PERMISSION,
  TNA_BY_STYLE_VIEW_PERMISSION,
  TNA_TO_DO_LIST_VIEW_PERMISSION,
  UNIT_CREATE_PERMISSION,
  UNIT_DELETE_PERMISSION,
  UNIT_EDIT_PERMISSION,
  UNIT_VIEW_PERMISSION,
  UPLOAD_BANK_PERMISSION,
  UPLOAD_BOM_PERMISSION,
  UPLOAD_BRANCH_PERMISSION,
  UPLOAD_BRAND_PERMISSION,
  UPLOAD_BUYER_PERMISSION,
  UPLOAD_BUYING_OFFICE_PERMISSION,
  UPLOAD_COLOR_PERMISSION,
  UPLOAD_MERCHANDISER_PERMISSION,
  UPLOAD_PO_PERMISSION,
  UPLOAD_SALES_CONTRACT_PERMISSION,
  UPLOAD_SIZE_PERMISSION,
  UPLOAD_STYLE_PERMISSION,
  UPLOAD_SUBSTYLE_PERMISSION,
  UPLOAD_SUPPLIER_PERMISSION,
  USER_CREATE_PERMISSION,
  USER_DELETE_PERMISSION,
  USER_EDIT_PERMISSION,
  USER_VIEW_PERMISSION,
  VIEW_ALL_ACTIVE_POS_PERMISSION,
  WAREHOUSE_CREATE_PERMISSION,
  WAREHOUSE_DELETE_PERMISSION,
  WAREHOUSE_EDIT_PERMISSION,
  WAREHOUSE_VIEW_PERMISSION,
  WASHING_SNAP_BUTTON_VIEW_PERMISSION,
  CARTON_WAREHOUSE_VIEW_PERMISSION,
  CARTON_FLOOR_VIEW_PERMISSION,
  CARTON_PARTITION_VIEW_PERMISSION,
  FABRIC_DEFECT_CATEGORY_VIEW_PERMISSION,
  FABRIC_INSPECTION_VIEW_PERMISSION,
  FABRIC_INSPECTION_CREATE_PERMISSION,
  FABRIC_INSPECTION_EDIT_PERMISSION,
  FABRIC_INSPECTION_DELETE_PERMISSION,
  FINAL_PRODUCT_INSPECTION_VIEW_PERMISSION,
  FINAL_PRODUCT_INSPECTION_CREATE_PERMISSION,
  FINAL_PRODUCT_INSPECTION_EDIT_PERMISSION,
  FINAL_PRODUCT_INSPECTION_DELETE_PERMISSION,
  TRANSPORTATION_COST_VIEW_PERMISSION,
  TRANSPORTATION_COST_CONFIG_VIEW_PERMISSION,
  TRANSPORTATION_COST_CONFIG_CREATE_PERMISSION,
  TRANSPORTATION_COST_CONFIG_EDIT_PERMISSION,
  TRANSPORTATION_COST_CONFIG_DELETE_PERMISSION,
  TRANSPORTATION_COST_ENTRY_VIEW_PERMISSION,
  TRANSPORTATION_COST_ENTRY_CREATE_PERMISSION,
  TRANSPORTATION_COST_ENTRY_EDIT_PERMISSION,
  TRANSPORTATION_COST_ENTRY_DELETE_PERMISSION,
  TRANSPORTATION_COST_ENTRY_PRINT_PERMISSION,
  PRODUCTION_PLANNING_LIST_VIEW_PERMISSION,
  CAPACITY_BOOKING_REPORT_VIEW_PERMISSION,
  BOOKING_CARTON_VIEW_PERMISSION,
  BOOKING_CARTON_CREATE_PERMISSION,
  BOOKING_CARTON_EDIT_PERMISSION,
  BOOKING_CARTON_DELETE_PERMISSION,
  NOTIFICATION_VIEW_PERMISSION,
  SAMPLE_REQUISITION_VIEW_PERMISSION,
  SAMPLE_REQUISITION_CREATE_PERMISSION,
  SAMPLE_REQUISITION_EDIT_PERMISSION,
  SAMPLE_REQUISITION_DELETE_PERMISSION,
  SAMPLE_TYPE_VIEW_PERMISSION,
  SAMPLE_TYPE_CREATE_PERMISSION,
  SAMPLE_TYPE_EDIT_PERMISSION,
  SAMPLE_TYPE_DELETE_PERMISSION,
} from "./permissions";

const defaultMenuItems = [
  {
    icon: <HomeOutlined />,
    label: (
      <Link to={"/"} replace={true}>
        Dashboard{" "}
      </Link>
    ),
    to: "/dashboard",
    key: "/dashboard",
    breadcrumbname: "Dashboard",
    allowedpermissions: [NO_PERMISSION_REQUIRED],
  },
  {
    icon: <RadiusSettingOutlined />,
    label: "Configuration",
    to: "#",
    key: "/configuration",
    children: [
      {
        label: <Link to="/configuration/organization"> Organizations </Link>,
        key: "/configuration/organization",
        to: "/configuration/organization",
        breadcrumbname: "Organizations",
        allowedpermissions: [
          ORGANIZATION_VIEW_PERMISSION,
          ORGANIZATION_CREATE_PERMISSION,
          ORGANIZATION_EDIT_PERMISSION,
          ORGANIZATION_DELETE_PERMISSION,
        ],
      },
      {
        label: (
          <Link to="/configuration/buyer" replace={true}>
            {" "}
            Buyer{" "}
          </Link>
        ),
        key: "/configuration/buyer",
        to: "/configuration/buyer",
        breadcrumbname: "Buyer",
        allowedpermissions: [
          BUYER_VIEW_PERMISSION,
          BUYER_CREATE_PERMISSION,
          BUYER_EDIT_PERMISSION,
          BUYER_DELETE_PERMISSION,
        ],
      },
      {
        label: (
          <Link to={"/configuration/buying-office"} replace={true}>
            {" "}
            Buying Office{" "}
          </Link>
        ),
        key: "/configuration/buying-office",
        to: "/configuration/buying-office",
        breadcrumbname: "Buying Office",
        allowedpermissions: [
          BUYING_OFFICE_VIEW_PERMISSION,
          BUYING_OFFICE_CREATE_PERMISSION,
          BUYING_OFFICE_EDIT_PERMISSION,
          BUYING_OFFICE_DELETE_PERMISSION,
        ],
      },
      {
        label: <Link to="/merchandising/sub-contract-factory">Sub-Contract Factory</Link>,
        key: "/merchandising/sub-contract-factory",
        to: "/merchandising/sub-contract-factory",
        breadcrumbname: "User Line Assign",
        allowedpermissions: [SUBCONTRACT_FACTORY_VIEW_PERMISSION],
      },
      {
        label: <Link to={"/configuration/supplier"}>Supplier</Link>,
        key: "/configuration/supplier",
        to: "/configuration/supplier",
        breadcrumbname: "Supplier",
        allowedpermissions: [
          SUPPLIER_VIEW_PERMISSION,
          SUPPLIER_CREATE_PERMISSION,
          SUPPLIER_EDIT_PERMISSION,
          SUPPLIER_DELETE_PERMISSION,
        ],
      },
      // {
      //   label: <Link to={"/configuration/item-type"}>Item Type</Link>,
      //   key: "/configuration/item-type",
      //   to: "/configuration/item-type",
      //   breadcrumbname: "Item Type",
      //   allowedpermissions: [
      //     ITEM_TYPE_VIEW_PERMISSION,
      //     ITEM_TYPE_CREATE_PERMISSION,
      //     ITEM_TYPE_EDIT_PERMISSION,
      //     ITEM_TYPE_DELETE_PERMISSION,
      //   ],
      // },
      {
        label: <Link to={"/configuration/item-category"}>Item Category</Link>,
        key: "/configuration/item-category",
        to: "/configuration/item-category",
        breadcrumbname: "Item Category",
        allowedpermissions: [
          ITEM_CATEGORY_VIEW_PERMISSION,
          ITEM_CATEGORY_CREATE_PERMISSION,
          ITEM_CATEGORY_EDIT_PERMISSION,
          ITEM_CATEGORY_DELETE_PERMISSION,
        ],
      },
      {
        label: <Link to={"/configuration/items"}>Item</Link>,
        key: "/configuration/items",
        to: "/configuration/items",
        breadcrumbname: "Item",
        allowedpermissions: [
          ITEM_VIEW_PERMISSION,
          ITEM_CREATE_PERMISSION,
          ITEM_EDIT_PERMISSION,
          ITEM_DELETE_PERMISSION,
        ],
      },

      {
        label: <Link to={"/configuration/item-types"}>Item Types</Link>,
        key: "/configuration/item-types",
        to: "/configuration/item-types",
        breadcrumbname: "Item Types",
        allowedpermissions: [
          ITEM_TYPES_VIEW_PERMISSION,
          ITEM_TYPES_CREATE_PERMISSION,
          ITEM_TYPES_EDIT_PERMISSION,
          ITEM_TYPES_DELETE_PERMISSION,
        ],
      },

      {
        label: <Link to={"/configuration/upload-item-ocr"}>Upload Item OCR</Link>,
        key: "/configuration/upload-item-ocr",
        to: "/configuration/upload-item-ocr",
        breadcrumbname: "Upload Item OCR",
        allowedpermissions: [ITEM_OCR_UPLOAD_PERMISSION],
      },
      {
        label: <Link to={"/configuration/sewing-line"}>Sewing Line</Link>,
        key: "/configuration/sewing-line",
        to: "/configuration/sewing-line",
        breadcrumbname: "Sewing Line",
        allowedpermissions: [
          SEWING_LINE_VIEW_PERMISSION,
          SEWING_LINE_CREATE_PERMISSION,
          SEWING_LINE_EDIT_PERMISSION,
          SEWING_LINE_DELETE_PERMISSION,
        ],
      },
      {
        label: <Link to={"/configuration/warehouse"}>Warehouse</Link>,
        key: "/configuration/warehouse",
        to: "/configuration/warehouse",
        breadcrumbname: "Warehouse",
        allowedpermissions: [
          WAREHOUSE_VIEW_PERMISSION,
          WAREHOUSE_CREATE_PERMISSION,
          WAREHOUSE_EDIT_PERMISSION,
          WAREHOUSE_DELETE_PERMISSION,
        ],
      },
      {
        label: <Link to={"/configuration/rack"}>Rack</Link>,
        key: "/configuration/rack",
        to: "/configuration/rack",
        breadcrumbname: "Rack",
        allowedpermissions: [
          RACK_VIEW_PERMISSION,
          RACK_CREATE_PERMISSION,
          RACK_EDIT_PERMISSION,
          RACK_DELETE_PERMISSION,
        ],
      },
      {
        label: <Link to={"/configuration/bin"}>Bin</Link>,
        key: "/configuration/bin",
        to: "/configuration/bin",
        breadcrumbname: "Bin",
        allowedpermissions: [BIN_VIEW_PERMISSION, BIN_CREATE_PERMISSION, BIN_EDIT_PERMISSION, BIN_DELETE_PERMISSION],
      },
      {
        label: <Link to={"/configuration/carton-warehouse"}>Carton Warehouse</Link>,
        key: "/configuration/carton-warehouse",
        to: "/configuration/carton-warehouse",
        breadcrumbname: "Carton Warehouse",
        allowedpermissions: [CARTON_WAREHOUSE_VIEW_PERMISSION],
      },
      {
        label: <Link to={"/configuration/carton-floor"}>Carton Floor</Link>,
        key: "/configuration/carton-floor",
        to: "/configuration/carton-floor",
        breadcrumbname: "Carton Floor",
        allowedpermissions: [CARTON_FLOOR_VIEW_PERMISSION],
      },
      {
        label: <Link to={"/configuration/carton-partition"}>Carton Partition</Link>,
        key: "/configuration/carton-partition",
        to: "/configuration/carton-partition",
        breadcrumbname: "Carton Partition",
        allowedpermissions: [CARTON_PARTITION_VIEW_PERMISSION],
      },
      {
        label: <Link to={"/configuration/fabric-defect-category"}>Fabric Defect Category</Link>,
        key: "/configuration/fabric-defect-category",
        to: "/configuration/fabric-defect-category",
        breadcrumbname: "Fabric Defect Category",
        allowedpermissions: [FABRIC_DEFECT_CATEGORY_VIEW_PERMISSION],
      },
      {
        label: <Link to={"/configuration/unit"}>Unit</Link>,
        key: "/configuration/unit",
        to: "/configuration/unit",
        breadcrumbname: "Unit",
        allowedpermissions: [
          UNIT_VIEW_PERMISSION,
          UNIT_CREATE_PERMISSION,
          UNIT_EDIT_PERMISSION,
          UNIT_DELETE_PERMISSION,
        ],
      },
      {
        label: <Link to={"/configuration/color"}>Color</Link>,
        key: "/configuration/color",
        to: "/configuration/color",
        breadcrumbname: "color",
        allowedpermissions: [
          COLOR_VIEW_PERMISSION,
          COLOR_CREATE_PERMISSION,
          COLOR_EDIT_PERMISSION,
          COLOR_DELETE_PERMISSION,
        ],
      },
      {
        label: <Link to={"/configuration/size"}>Size</Link>,
        key: "/configuration/size",
        to: "/configuration/size",
        breadcrumbname: "size",
        allowedpermissions: [
          SIZE_VIEW_PERMISSION,
          SIZE_CREATE_PERMISSION,
          SIZE_EDIT_PERMISSION,
          SIZE_DELETE_PERMISSION,
        ],
      },
      {
        label: <Link to={"/configuration/unit-convertion"}>Unit Convertion</Link>,
        key: "/configuration/unit-convertion",
        to: "/configuration/unit-convertion",
        breadcrumbname: "unit-convertion",
        allowedpermissions: [
          UNIT_VIEW_PERMISSION,
          UNIT_CREATE_PERMISSION,
          UNIT_EDIT_PERMISSION,
          UNIT_DELETE_PERMISSION,
        ],
      },
      {
        label: <Link to={"/configuration/challan"}>Challan</Link>,
        key: "/configuration/challan",
        to: "/configuration/challan",
        breadcrumbname: "Challan",
        allowedpermissions: [
          CHALLAN_CREATE_PERMISSION,
          CHALLAN_EDIT_PERMISSION,
          CHALLAN_VIEW_PERMISSION,
          CHALLAN_DELETE_PERMISSION,
        ],
      },
      {
        label: <Link to={"/configuration/garment-category"}>Garment Category</Link>,
        key: "/configuration/garment-category",
        to: "/configuration/garment-category",
        breadcrumbname: "Garment Category",
        allowedpermissions: [
          GARMENT_CATEGORY_VIEW_PERMISSION,
          GARMENT_CATEGORY_CREATE_PERMISSION,
          GARMENT_CATEGORY_EDIT_PERMISSION,
          GARMENT_CATEGORY_DELETE_PERMISSION,
        ],
      },
      {
        label: <Link to={"/configuration/garment-type"}>Garment Type</Link>,
        key: "/configuration/garment-type",
        to: "/configuration/garment-type",
        breadcrumbname: "Garment Type",
        allowedpermissions: [
          GARMENT_TYPE_VIEW_PERMISSION,
          GARMENT_TYPE_CREATE_PERMISSION,
          GARMENT_TYPE_EDIT_PERMISSION,
          GARMENT_TYPE_DELETE_PERMISSION,
        ],
      },
      {
        label: <Link to={"/configuration/air-hole-types"}>Air Hole Types</Link>,
        key: "/configuration/air-hole-types",
        to: "/configuration/air-hole-types",
        breadcrumbname: "Air Hole Types",
        allowedpermissions: [
          AIR_HOLE_TYPE_VIEW_PERMISSION,
          AIR_HOLE_TYPE_CREATE_PERMISSION,
          AIR_HOLE_TYPE_EDIT_PERMISSION,
          AIR_HOLE_TYPE_DELETE_PERMISSION,
        ],
      },
      {
        label: <Link to={"/configuration/au-formulas"}>AU Formulas</Link>,
        key: "/configuration/au-formulas",
        to: "/configuration/au-formulas",
        breadcrumbname: "AU Formulas",
        allowedpermissions: [
          AU_FORMULA_VIEW_PERMISSION,
          AU_FORMULA_CREATE_PERMISSION,
          AU_FORMULA_EDIT_PERMISSION,
          AU_FORMULA_DELETE_PERMISSION,
        ],
      },
      {
        label: <Link to={"/configuration/carton-types"}>Carton Types</Link>,
        key: "/configuration/carton-types",
        to: "/configuration/carton-types",
        breadcrumbname: "Carton Types",
        allowedpermissions: [
          CARTON_TYPE_VIEW_PERMISSION,
          CARTON_TYPE_CREATE_PERMISSION,
          CARTON_TYPE_EDIT_PERMISSION,
          CARTON_TYPE_DELETE_PERMISSION,
        ],
      },
      {
        label: <Link to={"/configuration/gusset-types"}>Gusset Types</Link>,
        key: "/configuration/gusset-types",
        to: "/configuration/gusset-types",
        breadcrumbname: "Gusset Types",
        allowedpermissions: [
          GUSSET_TYPE_VIEW_PERMISSION,
          GUSSET_TYPE_CREATE_PERMISSION,
          GUSSET_TYPE_EDIT_PERMISSION,
          GUSSET_TYPE_DELETE_PERMISSION,
        ],
      },
      {
        label: <Link to={"/configuration/plies"}>Plies</Link>,
        key: "/configuration/plies",
        to: "/configuration/plies",
        breadcrumbname: "Plies",
        allowedpermissions: [PLY_VIEW_PERMISSION, PLY_CREATE_PERMISSION, PLY_EDIT_PERMISSION, PLY_DELETE_PERMISSION],
      },
      {
        label: <Link to={"/configuration/poly-types"}>Poly Types</Link>,
        key: "/configuration/poly-types",
        to: "/configuration/poly-types",
        breadcrumbname: "Poly Types",
        allowedpermissions: [
          POLY_TYPE_VIEW_PERMISSION,
          POLY_TYPE_CREATE_PERMISSION,
          POLY_TYPE_EDIT_PERMISSION,
          POLY_TYPE_DELETE_PERMISSION,
        ],
      },
      {
        label: <Link to={"/configuration/supporting-material-types"}>Supporting Material Types</Link>,
        key: "/configuration/supporting-material-types",
        to: "/configuration/supporting-material-types",
        breadcrumbname: "Supporting Material Types",
        allowedpermissions: [
          SUPPORTING_MATERIAL_TYPE_VIEW_PERMISSION,
          SUPPORTING_MATERIAL_TYPE_CREATE_PERMISSION,
          SUPPORTING_MATERIAL_TYPE_EDIT_PERMISSION,
          SUPPORTING_MATERIAL_TYPE_DELETE_PERMISSION,
        ],
      },
      {
        label: <Link to={"/configuration/inquiry-reasons"}>Inquiry Reasons</Link>,
        key: "/configuration/inquiry-reasons",
        to: "/configuration/inquiry-reasons",
        breadcrumbname: "Inquiry Reasons",
        allowedpermissions: [
          INQUIRY_REASONS_VIEW_PERMISSION,
          INQUIRY_REASONS_CREATE_PERMISSION,
          INQUIRY_REASONS_EDIT_PERMISSION,
          INQUIRY_REASONS_DELETE_PERMISSION,
        ],
      },
      {
        label: <Link to={"/configuration/inquiry-remarks"}>Inquiry Remarks</Link>,
        key: "/configuration/inquiry-remarks",
        to: "/configuration/inquiry-remarks",
        breadcrumbname: "Inquiry Remarks",
        allowedpermissions: [
          INQUIRY_REMARKS_VIEW_PERMISSION,
          INQUIRY_REMARKS_CREATE_PERMISSION,
          INQUIRY_REMARKS_EDIT_PERMISSION,
          INQUIRY_REMARKS_DELETE_PERMISSION,
        ],
      },
      {
        label: <Link to="/ot-signal-section">OT Signal Section</Link>,
        key: "/ot-signal-section",
        to: "/ot-signal-section",
        breadcrumbname: "OT Signal Section",
        allowedpermissions: [OT_SIGNAL_SECTION_VIEW_PERMISSION],
      },
      {
        label: <Link to="/ot-signal">OT Signal</Link>,
        key: "/ot-signal",
        to: "/ot-signal",
        breadcrumbname: "OT Signal",
        allowedpermissions: [OT_SIGNAL_VIEW_PERMISSION],
      },
      {
        label: (
          <Link to="/configuration/banks" replace={true}>
            {" "}
            Banks{" "}
          </Link>
        ),
        key: "/configuration/banks",
        to: "/configuration/banks",
        breadcrumbname: "Banks",
        allowedpermissions: [
          BANK_VIEW_PERMISSION,
          BANK_CREATE_PERMISSION,
          BANK_EDIT_PERMISSION,
          BANK_DELETE_PERMISSION,
        ],
      },
      {
        label: (
          <Link to="/configuration/branches" replace={true}>
            {" "}
            Branches{" "}
          </Link>
        ),
        key: "/configuration/branches",
        to: "/configuration/branches",
        breadcrumbname: "Branches",
        allowedpermissions: [
          BRANCH_VIEW_PERMISSION,
          BRANCH_CREATE_PERMISSION,
          BRANCH_EDIT_PERMISSION,
          BRANCH_DELETE_PERMISSION,
        ],
      },
      {
        label: (
          <Link to="/configuration/accounts" replace={true}>
            {" "}
            Accounts{" "}
          </Link>
        ),
        key: "/configuration/accounts",
        to: "/configuration/accounts",
        breadcrumbname: "Accounts",
        allowedpermissions: [
          ACCOUNT_VIEW_PERMISSION,
          ACCOUNT_CREATE_PERMISSION,
          ACCOUNT_EDIT_PERMISSION,
          ACCOUNT_DELETE_PERMISSION,
        ],
      },
      {
        label: <Link to="/configuration/garments-parts">Garments Parts</Link>,
        key: "/configuration/garments-parts",
        to: "/configuration/garments-parts",
        breadcrumbname: "Garments Parts",
        allowedpermissions: [
          GARMENTS_PARTS_CREATE_PERMISSION,
          GARMENTS_PARTS_EDIT_PERMISSION,
          GARMENTS_PARTS_VIEW_PERMISSION,
          GARMENTS_PARTS_DELETE_PERMISSION,
        ],
      },
      {
        label: <Link to="/configuration/stock-lot">Stock Lot</Link>,
        key: "/configuration/stock-lot",
        to: "/configuration/stock-lot",
        breadcrumbname: "Stock Lot",
        allowedpermissions: [
          STOCK_LOT_VIEW_PERMISSION,
          STOCK_LOT_CREATE_PERMISSION,
          STOCK_LOT_EDIT_PERMISSION,
          STOCK_LOT_DELETE_PERMISSION,
        ],
      },
      {
        label: <Link to="/ex-factory/packing-report-template">Packing Report Template</Link>,
        key: "/ex-factory/packing-report-template",
        to: "/ex-factory/packing-report-template",
        breadcrumbname: "Packing Report Template",
        allowedpermissions: [
          PACKING_REPORT_TEMPLATE_VIEW_PERMISSION,
          PACKING_REPORT_TEMPLATE_STORE_PERMISSION,
          PACKING_REPORT_TEMPLATE_UPDATE_PERMISSION,
          PACKING_REPORT_TEMPLATE_DELETE_PERMISSION,
        ],
      },
      {
        label: <Link to="/configuration/packing-line">Packing Line</Link>,
        key: "/configuration/packing-line",
        to: "/configuration/packing-line",
        breadcrumbname: "Packing Line",
        allowedpermissions: [
          PACKING_LINE_CREATE_PERMISSION,
          PACKING_LINE_EDIT_PERMISSION,
          PACKING_LINE_VIEW_PERMISSION,
          PACKING_LINE_DELETE_PERMISSION,
        ],
      },
      {
        label: <Link to="/configuration/packing-table">Packing Table</Link>,
        key: "/configuration/packing-table",
        to: "/configuration/packing-table",
        breadcrumbname: "Packing Table",
        allowedpermissions: [
          PACKING_TABLE_VIEW_PERMISSION,
          PACKING_TABLE_CREATE_PERMISSION,
          PACKING_TABLE_EDIT_PERMISSION,
          PACKING_TABLE_DELETE_PERMISSION,
        ],
      },
      {
        label: <Link to="/configuration/packing-operator-mapping">Packer Man Mapping</Link>,
        key: "/configuration/packing-operator-mapping",
        to: "/configuration/packing-operator-mapping",
        breadcrumbname: "Packer Man Mapping",
        allowedpermissions: [
          PACKING_OPERATOR_MAPPING_VIEW_PERMISSION,
          PACKING_OPERATOR_MAPPING_CREATE_PERMISSION,
          PACKING_OPERATOR_MAPPING_EDIT_PERMISSION,
          PACKING_OPERATOR_MAPPING_DELETE_PERMISSION,
        ],
      },
      {
        label: <Link to="/merchandising/sample-type">Type of Sample</Link>,
        key: "/merchandising/sample-type",
        to: "/merchandising/sample-type",
        breadcrumbname: "Type of Sample",
        allowedpermissions: [
          SAMPLE_TYPE_VIEW_PERMISSION,
          SAMPLE_TYPE_CREATE_PERMISSION,
          SAMPLE_TYPE_EDIT_PERMISSION,
          SAMPLE_TYPE_DELETE_PERMISSION,
        ],
      },
    ],
  },
  {
    icon: <SettingOutlined />,
    label: "Settings",
    key: "/settings",
    children: [
      {
        label: <Link to={"/settings/users"}>Users</Link>,
        key: "/settings/users",
        to: "/settings/users",
        allowedpermissions: [
          USER_VIEW_PERMISSION,
          USER_CREATE_PERMISSION,
          USER_EDIT_PERMISSION,
          USER_DELETE_PERMISSION,
        ],
      },
      {
        label: (
          <Link to={"/settings/role"} replace={true}>
            User Role
          </Link>
        ),
        key: "/settings/role",
        to: "/settings/role",
        breadcrumbname: "UserRole",
        allowedpermissions: [
          ROLE_VIEW_PERMISSION,
          ROLE_CREATE_PERMISSION,
          ROLE_EDIT_PERMISSION,
          ROLE_DELETE_PERMISSION,
        ],
      },
      {
        label: (
          <Link to={"/settings/permissions"} replace={true}>
            Permission
          </Link>
        ),
        key: "/settings/permissions",
        to: "/settings/permissions",
        breadcrumbname: "Permissions",
        allowedpermissions: [
          PERMISSION_VIEW_PERMISSION,
          PERMISSION_CREATE_PERMISSION,
          PERMISSION_EDIT_PERMISSION,
          PERMISSION_DELETE_PERMISSION,
        ],
      },
      {
        label: <Link to={"/tanda/department"}>Department</Link>,
        key: "/tanda/department",
        to: "/department",
        allowedpermissions: [
          TNA_DEPARTMENT_CREATE_PERMISSION,
          TNA_DEPARTMENT_VIEW_PERMISSION,
          TNA_DEPARTMENT_EDIT_PERMISSION,
          TNA_DEPARTMENT_DELETE_PERMISSION,
        ],
      },
      {
        label: <Link to={"/settings/remedy-map"}>Remedy Map</Link>,
        key: "/settings/remedy-map",
        to: "/remedy-map",
        allowedpermissions: [
          PROBLEM_REMEDY_MAP_VIEW_PERMISSION,
          PROBLEM_REMEDY_MAP_CREATE_PERMISSION,
          PROBLEM_REMEDY_MAP_EDIT_PERMISSION,
          PROBLEM_REMEDY_MAP_DELETE_PERMISSION,
        ],
      },
      {
        label: (
          <Link to={"/settings/notification-slugs"} replace={true}>
            Notification Slugs
          </Link>
        ),
        key: "/settings/notification-slugs",
        to: "/settings/notification-slugs",
        allowedpermissions: [
          NOTIFICATION_SLUG_VIEW_PERMISSION,
          NOTIFICATION_SLUG_CREATE_PERMISSION,
          NOTIFICATION_SLUG_EDIT_PERMISSION,
          NOTIFICATION_SLUG_DELETE_PERMISSION,
        ],
      },
      {
        label: (
          <Link to={"/settings/notification-settings"} replace={true}>
            Notification Settings
          </Link>
        ),
        key: "/settings/notification-settings",
        to: "/settings/notification-settings",
        breadcrumbname: "NotificationSettings",
        allowedpermissions: [
          NOTIFICATION_SETTING_VIEW_PERMISSION,
          NOTIFICATION_SETTING_CREATE_PERMISSION,
          NOTIFICATION_SETTING_EDIT_PERMISSION,
          NOTIFICATION_SETTING_DELETE_PERMISSION,
        ],
      },
      {
        label: (
          <Link to={"/settings/permission"} replace={true}>
            Permission Settings
          </Link>
        ),
        key: "/settings/permission",
        to: "/settings/permission",
        breadcrumbname: "PermissionSettings",
        allowedpermissions: [
          PERMISSION_VIEW_PERMISSION,
          PERMISSION_CREATE_PERMISSION,
          PERMISSION_EDIT_PERMISSION,
          PERMISSION_DELETE_PERMISSION,
        ],
      },
    ],
  },
  {
    icon: <ThunderboltOutlined />,
    label: "Production Planning",
    key: "/production-planning/dashboard",
    children: [
      {
        label: (
          <Link to={"/production-planning/dashboard"} replace={true}>
            Dashboard
          </Link>
        ),
        key: "/production-planning/dashboard",
        to: "/production-planning/dashboard",
        allowedpermissions: [PLAN_DASHBOARD_VIEW_PERMISSION],
      },
      {
        label: (
          <Link to={"/production-planning/weekends"} replace={true}>
            Weekends
          </Link>
        ),
        key: "/production-planning/weekends",
        to: "/production-planning/weekends",
        allowedpermissions: [
          PP_WEEKEND_VIEW_PERMISSION,
          PP_WEEKEND_CREATE_PERMISSION,
          PP_WEEKEND_EDIT_PERMISSION,
          PP_WEEKEND_DELETE_PERMISSION,
        ],
      },
      {
        label: (
          <Link to={"/production-planning/holidays"} replace={true}>
            Holiday
          </Link>
        ),
        key: "/production-planning/holidays",
        to: "/production-planning/holidays",
        allowedpermissions: [
          PP_HOLIDAY_VIEW_PERMISSION,
          PP_HOLIDAY_CREATE_PERMISSION,
          PP_HOLIDAY_EDIT_PERMISSION,
          PP_HOLIDAY_DELETE_PERMISSION,
        ],
      },
      {
        label: (
          <Link to={"/production-planning/exceptions"} replace={true}>
            Exceptions
          </Link>
        ),
        key: "/production-planning/exceptions",
        to: "/production-planning/exceptions",
        allowedpermissions: [
          PP_EXCEPTION_VIEW_PERMISSION,
          PP_EXCEPTION_CREATE_PERMISSION,
          PP_EXCEPTION_EDIT_PERMISSION,
          PP_EXCEPTION_DELETE_PERMISSION,
        ],
      },
      {
        label: (
          <Link to={"/production-planning/plan-entry"} replace={true}>
            Plan Entry
          </Link>
        ),
        key: "/production-planning/plan-entry",
        to: "/production-planning/plan-entry",
        allowedpermissions: [PLAN_CREATE_PERMISSION],
      },
      {
        label: (
          <Link to={"/production-planning/list"} replace={true}>
            Production Planning List
          </Link>
        ),
        key: "/production-planning/list",
        to: "/production-planning/list",
        allowedpermissions: [PRODUCTION_PLANNING_LIST_VIEW_PERMISSION],
      },
      {
        label: (
          <Link to={"/production-planning/planning-report"} replace={true}>
            Production Planning Report
          </Link>
        ),
        key: "/production-planning/planning-report",
        to: "/production-planning/planning-report",
        allowedpermissions: [PRODUCTION_PLANNING_LIST_VIEW_PERMISSION, PLAN_DASHBOARD_VIEW_PERMISSION],
      },
    ],
  },
  {
    icon: <SkinOutlined />,
    label: "Merchandising",
    key: "/merchandising",
    children: [
      {
        label: <Link to={"/merchandising/buyer-inquiry"}>Buyer Inquiry</Link>,
        key: "/merchandising/buyer-inquiry",
        to: "/buyer-inquiry",
        allowedpermissions: [
          BUYER_INQUIRY_VIEW_PERMISSION,
          BUYER_INQUIRY_CREATE_PERMISSION,
          BUYER_INQUIRY_EDIT_PERMISSION,
          BUYER_INQUIRY_DELETE_PERMISSION,
        ],
      },
      // {
      //   label: <Link to={"/merchandising/capacity-booking"}>Capacity Booking</Link>,
      //   key: "/merchandising/capacity-booking",
      //   to: "/capacity-booking",
      //   allowedpermissions: [
      //     CAPACITY_BOOKING_VIEW_PERMISSION,
      //     CAPACITY_BOOKING_CREATE_PERMISSION,
      //     CAPACITY_BOOKING_EDIT_PERMISSION,
      //     CAPACITY_BOOKING_DELETE_PERMISSION,
      //   ],
      // },
      {
        label: <Link to={"/merchandising/style"}>Style </Link>,
        key: "/merchandising/style",
        to: "/style",
        allowedpermissions: [
          STYLE_VIEW_PERMISSION,
          STYLE_CREATE_PERMISSION,
          STYLE_EDIT_PERMISSION,
          STYLE_DELETE_PERMISSION,
        ],
      },
      {
        label: <Link to={"/merchandising/sales-contact"}>Sales Contract</Link>,
        key: "/merchandising/sales-contact",
        to: "/sales-contact",
        allowedpermissions: [
          SALES_CONTRACT_VIEW_PERMISSION,
          SALES_CONTRACT_CREATE_PERMISSION,
          SALES_CONTRACT_EDIT_PERMISSION,
          SALES_CONTRACT_DELETE_PERMISSION,
        ],
      },
      {
        label: <Link to={"/merchandising/sub-sales-contact"}>Sub Contract</Link>,
        key: "/merchandising/sub-sales-contact",
        to: "/merchandising/sub-sales-contact",
        allowedpermissions: [
          SALES_CONTRACT_VIEW_PERMISSION,
          SALES_CONTRACT_CREATE_PERMISSION,
          SALES_CONTRACT_EDIT_PERMISSION,
          SALES_CONTRACT_DELETE_PERMISSION,
        ],
      },
      {
        label: (
          <Link to={"/production-planning/planningRequests"} replace={true}>
            Planning Request
          </Link>
        ),
        key: "/production-planning/planningRequests",
        to: "/production-planning/planningRequests",
        allowedpermissions: [
          PP_PLANNING_REQUEST_CREATE_PERMISSION,
          PP_PLANNING_REQUEST_EDIT_PERMISSION,
          PP_PLANNING_REQUEST_VIEW_PERMISSION,
          PP_PLANNING_REQUEST_DELETE_PERMISSION,
        ],
      },
      {
        label: <Link to={"/merchandising/purchase-order-breakdown"}>SC PO Breakdown</Link>,
        key: "/merchandising/purchase-order-breakdown",
        to: "/purchase-order-breakdown",
        allowedpermissions: [
          PURCHASE_ORDER_VIEW_PERMISSION,
          PURCHASE_ORDER_CREATE_PERMISSION,
          PURCHASE_ORDER_EDIT_PERMISSION,
          PURCHASE_ORDER_DELETE_PERMISSION,
        ],
      },
      {
        label: <Link to={"/merchandising/po-wise-purchase-order-breakdown"}>PO Breakdown</Link>,
        key: "/merchandising/po-wise-purchase-order-breakdown",
        to: "/po-wise-purchase-order-breakdown",
        allowedpermissions: [
          PURCHASE_ORDER_VIEW_PERMISSION,
          PURCHASE_ORDER_CREATE_PERMISSION,
          PURCHASE_ORDER_EDIT_PERMISSION,
          PURCHASE_ORDER_DELETE_PERMISSION,
        ],
      },
      {
        label: <Link to={"/merchandising/style-wise-quantity-breakdown"}>Style Wise Qty Breakdown</Link>,
        key: "/merchandising/style-wise-quantity-breakdown",
        to: "/order-details",
        allowedpermissions: [
          PURCHASE_ORDER_VIEW_PERMISSION,
          PURCHASE_ORDER_CREATE_PERMISSION,
          PURCHASE_ORDER_EDIT_PERMISSION,
          PURCHASE_ORDER_DELETE_PERMISSION,
        ],
      },
      {
        label: <Link to={"/merchandising/cost-estimate"}>Cost Estimate</Link>,
        key: "/merchandising/cost-estimate",
        to: "/merchandising/cost-estimate",
        allowedpermissions: [
          COST_ESTIMATE_CREATE_PERMISSION,
          COST_ESTIMATE_EDIT_PERMISSION,
          COST_ESTIMATE_VIEW_PERMISSION,
          COST_ESTIMATE_DELETE_PERMISSION,
        ],
      },
      {
        label: <Link to={"/merchandising/BOM"}>Bill Of Materials</Link>,
        key: "/merchandising/BOM",
        to: "/BOM",
        allowedpermissions: [
          BOM_VIEW_PERMISSION,
          BOM_CREATE_PERMISSION,
          BOM_EDIT_PERMISSION,
          BOM_DELETE_PERMISSION,
          BOM_EXPORT_PERMISSION,
        ],
      },
      {
        label: <Link to="/import/pi">Proforma Invoice</Link>,
        key: "/import/pi",
        to: "#",
        breadcrumbname: "Sales Contract",
        allowedpermissions: [PI_VIEW_PERMISSION, PI_CREATE_PERMISSION, PI_EDIT_PERMISSION, PI_DELETE_PERMISSION],
      },
      // {
      //   label: <Link to="/import/budget-pi">Budget VS PI</Link>,
      //   key: "/import/budget-pi",
      //   to: "#",
      //   breadcrumbname: "Sales Contract",
      //   allowedpermissions: [PI_BUDGET_VIEW_PERMISSION],
      // },
      // {
      //   label: (
      //     <Link to={"/merchandising/purchase-order-new"}>Buyer PO (New)</Link>
      //   ),
      //   key: "/merchandising/purchase-order-new",
      //   to: "/order-details",
      //   allowedpermissions: [
      //     "purchase-order-view-permission",
      //     "purchase-order-create-permission",
      //     "purchase-order-edit-permission",
      //     "purchase-order-delete-permission",
      //   ],
      // },

      {
        label: <Link to={"/merchandising/sales-contract-360"}>Sales Contract 360</Link>,
        key: "/merchandising/sales-contract-360",
        to: "/sales-contract-360",
        // TODO Add Permissions SALES_CONTRACT_360_VIEW_PERMISSION
        allowedpermissions: [SALES_CONTRACT_360_VIEW_PERMISSION],
      },
      {
        label: <Link to="/import/details/1">Local Invoice</Link>,
        key: "/merchandising/import/details/1",
        to: "/merchandising/import/details/1",
        breadcrumbname: "Local Invoice",
        allowedpermissions: [
          DAILY_IMPORT_POSITION_VIEW_PERMISSION,
          DAILY_IMPORT_POSITION_CREATE_PERMISSION,
          DAILY_IMPORT_POSITION_EDIT_PERMISSION,
          DAILY_IMPORT_POSITION_DELETE_PERMISSION,
        ],
      },
      {
        label: <Link to="/local-purchase-reconciliation">MRR</Link>,
        key: "/local-purchase-reconciliation",
        to: "/local-purchase-reconciliation",
        breadcrumbname: "Local Purchase Reconciliation",
        allowedpermissions: [
          LOCAL_PURCHASE_RECONCILIATION_VIEW_PERMISSION,
          LOCAL_PURCHASE_RECONCILIATION_CREATE_PERMISSION,
          LOCAL_PURCHASE_RECONCILIATION_EDIT_PERMISSION,
          LOCAL_PURCHASE_RECONCILIATION_DELETE_PERMISSION,
        ],
      },
      {
        label: <Link to="/carton-booking">Carton & Poly Booking</Link>,
        key: "/carton-booking",
        to: "/carton-booking",
        breadcrumbname: "Carton & Poly Booking",
        allowedpermissions: [
          BOOKING_CARTON_VIEW_PERMISSION,
          BOOKING_CARTON_CREATE_PERMISSION,
          BOOKING_CARTON_EDIT_PERMISSION,
          BOOKING_CARTON_DELETE_PERMISSION,
        ],
      },
      {
        label: <Link to="/merchandising/sample-requisition">Sample Requisition</Link>,
        key: "/merchandising/sample-requisition",
        to: "/merchandising/sample-requisition",
        breadcrumbname: "Sample Requisition",
        allowedpermissions: [
          SAMPLE_REQUISITION_VIEW_PERMISSION,
          SAMPLE_REQUISITION_CREATE_PERMISSION,
          SAMPLE_REQUISITION_EDIT_PERMISSION,
          SAMPLE_REQUISITION_DELETE_PERMISSION,
        ],
      },
      // {
      //   breadcrumbname: "Capacity Booking Report",
      //   label: (
      //     <Link to={"/production-planning/booking-qty"} replace={true}>
      //       Booking QTY
      //     </Link>
      //   ),
      //   key: "/production-planning/booking-qty",
      //   to: "/production-planning/booking-qty",
      //   allowedpermissions: [
      //     BOOKING_QTY_VIEW_PERMISSION,
      //     BOOKING_QTY_CREATE_PERMISSION,
      //     BOOKING_QTY_EDIT_PERMISSION,
      //     BOOKING_QTY_DELETE_PERMISSION,
      //   ],
      // },
      {
        label: (
          <Link to={"/production-planning/capacity-booking-report"} replace={true}>
            Capacity Booking Report
          </Link>
        ),
        key: "/production-planning/capacity-booking-report",
        to: "/production-planning/capacity-booking-report",
        allowedpermissions: [CAPACITY_BOOKING_REPORT_VIEW_PERMISSION],
      },
    ],
  },
  {
    icon: <ClusterOutlined />,
    label: "T & A",
    key: "/tanda",
    children: [
      {
        label: <Link to={"/tanda/process"}>Process</Link>,
        key: "/tanda/process",
        to: "/process",
        allowedpermissions: [
          TNA_PROCESS_CREATE_PERMISSION,
          TNA_PROCESS_VIEW_PERMISSION,
          TNA_PROCESS_EDIT_PERMISSION,
          TNA_PROCESS_DELETE_PERMISSION,
        ],
      },
      // {
      //   label: <Link to={"/tanda/task"}>Task</Link>,
      //   key: "/tanda/task",
      //   to: "/task",
      //   allowedpermissions: [
      //     TNA_TASK_CREATE_PERMISSION,
      //     TNA_TASK_VIEW_PERMISSION,
      //     TNA_TASK_EDIT_PERMISSION,
      //     TNA_TASK_DELETE_PERMISSION,
      //   ],
      // },
      {
        label: <Link to={"/tanda/new-task"}>Task</Link>,
        key: "/tanda/new-task",
        to: "/new-task",
        allowedpermissions: [
          TNA_TASK_CREATE_PERMISSION,
          TNA_TASK_VIEW_PERMISSION,
          TNA_TASK_EDIT_PERMISSION,
          TNA_TASK_DELETE_PERMISSION,
        ],
      },
      // {
      //   label: <Link to={"/tanda/template"}>Template</Link>,
      //   key: "/tanda/template",
      //   to: "/template",
      //   allowedpermissions: [
      //     TNA_TEMPLATE_CREATE_PERMISSION,
      //     TNA_TEMPLATE_VIEW_PERMISSION,
      //     TNA_TEMPLATE_EDIT_PERMISSION,
      //     TNA_TEMPLATE_DELETE_PERMISSION,
      //   ],
      // },
      {
        label: <Link to={"/tanda/new-template"}>Template</Link>,
        key: "/tanda/new-template",
        to: "/new-template",
        allowedpermissions: [
          TNA_TEMPLATE_CREATE_PERMISSION,
          TNA_TEMPLATE_VIEW_PERMISSION,
          TNA_TEMPLATE_EDIT_PERMISSION,
          TNA_TEMPLATE_DELETE_PERMISSION,
        ],
      },
      {
        label: <Link to={"/tanda/tna-by-styles"}>TNA</Link>,
        key: "/tanda/tna-by-styles",
        to: "/tna-by-styles",
        allowedpermissions: [
          TNA_BY_STYLE_CREATE_PERMISSION,
          TNA_BY_STYLE_VIEW_PERMISSION,
          TNA_BY_STYLE_EDIT_PERMISSION,
          TNA_BY_STYLE_DELETE_PERMISSION,
        ],
      },
      // {
      //   label: <Link to={"/tanda/plan-list"}>TNA</Link>,
      //   key: "/tanda/plan-list",
      //   to: "/plan",
      //   allowedpermissions: [
      //     TNA_PLAN_CREATE_PERMISSION,
      //     TNA_PLAN_VIEW_PERMISSION,
      //     TNA_PLAN_EDIT_PERMISSION,
      //     TNA_PLAN_DELETE_PERMISSION,
      //   ],
      // },
      // {
      //   label: <Link to={"/tanda/todo-list"}>Todo List</Link>,
      //   key: "/tanda/todo-lis",
      //   to: "/tanda/todo-lis",
      //   allowedpermissions: [TNA_TO_DO_LIST_VIEW_PERMISSION],
      // },
      {
        label: <Link to={"/tanda/new-todo-list"}>Todo List</Link>,
        key: "/tanda/new-todo-list",
        to: "/tanda/new-todo-list",
        breadcrumbname: "New Todo List",
        allowedpermissions: [TNA_TO_DO_LIST_VIEW_PERMISSION],
      },
      {
        label: <Link to={"/tanda/new-summary"}>Summary</Link>,
        key: "/tanda/new-summary",
        to: "/tanda/new-summary",
        breadcrumbname: "New Summary",
        allowedpermissions: [TNA_SUMMARY_VIEW_PERMISSION],
      },
      // {
      //   label: <Link to={"/tanda/summary"}>Summary</Link>,
      //   key: "/tanda/summary",
      //   to: "/summary",
      //   allowedpermissions: [TNA_SUMMARY_VIEW_PERMISSION],
      // },
    ],
  },
  {
    icon: <RobotOutlined />,
    label: "Industrial Engineering (IE)",
    key: "/industrial-engineering",
    children: [
      {
        label: <Link to={"/merchandising/learning-curves"}>Learning Curve </Link>,
        key: "/merchandising/learning-curves",
        to: "/merchandising/learning-curves",
        allowedpermissions: [
          LEARNING_CURVE_VIEW_PERMISSION,
          LEARNING_CURVE_CREATE_PERMISSION,
          LEARNING_CURVE_EDIT_PERMISSION,
          LEARNING_CURVE_DELETE_PERMISSION,
        ],
      },
      {
        label: <Link to={"/configuration/ob-machine"}>Machine Required</Link>,
        key: "/configuration/ob-machine",
        to: "/configuration/ob-machine",
        breadcrumbname: "ob-machine",
        allowedpermissions: [
          OB_MACHINE_VIEW_PERMISSION,
          OB_MACHINE_CREATE_PERMISSION,
          OB_MACHINE_EDIT_PERMISSION,
          OB_MACHINE_DELETE_PERMISSION,
        ],
      },
      // {
      //   label: <Link to={"/configuration/ob-section"}>OB Section</Link>,
      //   key: "/configuration/ob-section",
      //   to: "/configuration/ob-section",
      //   breadcrumbname: "ob-section",
      //   allowedpermissions: [
      //     OB_SECTION_VIEW_PERMISSION,
      //     OB_SECTION_CREATE_PERMISSION,
      //     OB_SECTION_EDIT_PERMISSION,
      //     OB_SECTION_DELETE_PERMISSION,
      //   ],
      // },
      {
        label: <Link to={"/configuration/ob-sam-data-bank"}>SAM Data Bank</Link>,
        key: "/configuration/ob-sam-data-bank",
        to: "/configuration/ob-sam-data-bank",
        breadcrumbname: "ob-sam-data-bank",
        allowedpermissions: [
          OB_SAM_DATA_BANK_VIEW_PERMISSION,
          OB_SAM_DATA_BANK_CREATE_PERMISSION,
          OB_SAM_DATA_BANK_EDIT_PERMISSION,
          OB_SAM_DATA_BANK_DELETE_PERMISSION,
        ],
      },
      {
        label: <Link to={"/configuration/ob-template"}>OB Template</Link>,
        key: "/configuration/ob-template",
        to: "/configuration/ob-template",
        breadcrumbname: "ob-template",
        allowedpermissions: [
          OB_TEMPLATE_VIEW_PERMISSION,
          OB_TEMPLATE_CREATE_PERMISSION,
          OB_TEMPLATE_EDIT_PERMISSION,
          OB_TEMPLATE_DELETE_PERMISSION,
        ],
      },
      {
        label: <Link to={"/merchandising/initial-sam-entry"}>Initial SAM</Link>,
        key: "/merchandising/initial-sam-entry",
        to: "/merchandising/initial-sam-entry",
        allowedpermissions: [INITIAL_SAM_MENU_PERMISSION, INITIAL_SAM_STORE_PERMISSION],
      },
      {
        label: <Link to={"/merchandising/operation-bulletin"}>Operation Bulletin </Link>,
        key: "/merchandising/operation-bulletin",
        to: "/merchandising/operation-bulletin",
        allowedpermissions: [OB_VIEW_PERMISSION, OB_CREATE_PERMISSION, OB_EDIT_PERMISSION, OB_DELETE_PERMISSION],
      },
    ],
  },
  {
    icon: <ShopOutlined />,
    label: "Inventory",
    key: "/inventory",
    children: [
      {
        label: <Link to={"/inventory/store/fabric-store-entry"}>Fabric Store</Link>,
        to: "/inventory/store/fabric-store-entry",
        key: "/inventory/store/fabric-store-entry",
        allowedpermissions: [
          INVENTORY_VIEW_PERMISSION,
          INVENTORY_CREATE_PERMISSION,
          INVENTORY_EDIT_PERMISSION,
          INVENTORY_DELETE_PERMISSION,
        ],
      },
      {
        label: <Link to={"/inventory/store/trims-store-entry"}>Trims and Accessories Store</Link>,
        to: "/inventory/store/trims-store-entry",
        key: "/inventory/store/trims-store-entry",
        allowedpermissions: [
          INVENTORY_VIEW_PERMISSION,
          INVENTORY_CREATE_PERMISSION,
          INVENTORY_EDIT_PERMISSION,
          INVENTORY_DELETE_PERMISSION,
        ],
      },
      {
        label: <Link to={"/inventory/finish-good"}>Finished Good</Link>,
        to: "/inventory/finish-good",
        key: "/inventory/finish-good",
        allowedpermissions: [
          FINISH_GARMENT_VIEW_PERMISSION,
          FINISH_GARMENT_CREATE_PERMISSION,
          FINISH_GARMENT_EDIT_PERMISSION,
          FINISH_GARMENT_DELETE_PERMISSION,
        ],
      },
      {
        label: <Link to={"/inventory/carton-inventory"}>Carton Inventory</Link>,
        to: "/inventory/carton-inventory",
        key: "/inventory/carton-inventory",
        allowedpermissions: [
          CARTON_INVENTORY_VIEW_PERMISSION,
          CARTON_INVENTORY_CREATE_PERMISSION,
          CARTON_INVENTORY_EDIT_PERMISSION,
          CARTON_INVENTORY_DELETE_PERMISSION,
        ],
      },
    ],
  },
  {
    icon: <FileDoneOutlined />,
    label: <Link to="/fabric-inspection">Fabric Inspection</Link>,
    key: "/fabric-inspection",
    to: "/fabric-inspection",
    breadcrumbname: "Fabric Inspection",
    allowedpermissions: [
      FABRIC_INSPECTION_VIEW_PERMISSION,
      FABRIC_INSPECTION_CREATE_PERMISSION,
      FABRIC_INSPECTION_EDIT_PERMISSION,
      FABRIC_INSPECTION_DELETE_PERMISSION,
    ],
  },
  {
    icon: <FileDoneOutlined />,
    label: <Link to="/final-inspection">Final Inspection</Link>,
    key: "/final-inspection",
    to: "/final-inspection",
    breadcrumbname: "Final Inspection",
    allowedpermissions: [
      FINAL_PRODUCT_INSPECTION_VIEW_PERMISSION,
      FINAL_PRODUCT_INSPECTION_CREATE_PERMISSION,
      FINAL_PRODUCT_INSPECTION_EDIT_PERMISSION,
      FINAL_PRODUCT_INSPECTION_DELETE_PERMISSION,
    ],
  },
  {
    icon: <ShoppingOutlined />,
    label: "Production",
    key: "/production",
    children: [
      {
        label: (
          <Link to={"/production/cutting"} replace={true}>
            Cutting
          </Link>
        ),
        to: "/production/cutting",
        key: "/production/cutting",
        allowedpermissions: [
          CUTTING_VIEW_PERMISSION,
          CUTTING_CREATE_PERMISSION,
          CUTTING_EDIT_PERMISSION,
          CUTTING_DELETE_PERMISSION,
        ],
      },
      // {
      //   label: (
      //     <Link to={"/production/cutting/cutting-item-entry"} replace={true}>
      //       Cutting Item
      //     </Link>
      //   ),
      //   to: "/production/cutting/cutting-item-entry",
      //   key: "/production/cutting/cutting-item-entry",
      //   allowedpermissions: [
      //     CUTTING_VIEW_PERMISSION,
      //     CUTTING_CREATE_PERMISSION,
      //     CUTTING_EDIT_PERMISSION,
      //     CUTTING_DELETE_PERMISSION,
      //   ],
      // },
      {
        label: <Link to={"/production/assignment"}>Assignment</Link>,
        to: "/production/assignment",
        key: "/production/assignment",
        allowedpermissions: [
          ASSIGNMENT_VIEW_PERMISSION,
          ASSIGNMENT_CREATE_PERMISSION,
          ASSIGNMENT_EDIT_PERMISSION,
          ASSIGNMENT_DELETE_PERMISSION,
        ],
      },
      // {
      //   label: <Link to={"/production/add-sewing"}>Sewing</Link>,
      //   to: "/production/sewing",
      //   key: "/production/add-sewing",
      //   allowedpermissions: [
      //     SEWING_VIEW_PERMISSION,
      //     SEWING_CREATE_PERMISSION,
      //     SEWING_EDIT_PERMISSION,
      //     SEWING_DELETE_PERMISSION,
      //   ],
      // },
      {
        label: <Link to={"/production/sewing-new"}>Sewing</Link>,
        to: "/production/sewing-new",
        key: "/production/sewing-new",
        allowedpermissions: [
          SEWING_VIEW_PERMISSION,
          SEWING_CREATE_PERMISSION,
          SEWING_EDIT_PERMISSION,
          SEWING_DELETE_PERMISSION,
        ],
      },
      {
        label: <Link to={"/production/folding"}>Folding</Link>,
        key: "/production/folding",
        to: "/production/folding",
        allowedpermissions: [
          FOLDING_VIEW_PERMISSION,
          FOLDING_CREATE_PERMISSION,
          FOLDING_EDIT_PERMISSION,
          FOLDING_DELETE_PERMISSION,
        ],
      },
      {
        label: <Link to={"/merchandising/packing-requirements"}>Packing Requirement</Link>,
        key: "/merchandising/packing-requirements",
        to: "/merchandising/packing-requirements",
        allowedpermissions: [
          PACKING_VIEW_PERMISSION,
          PACKING_CREATE_PERMISSION,
          PACKING_EDIT_PERMISSION,
          PACKING_DELETE_PERMISSION,
        ],
      },
      // {
      //   label: <Link to={"/production/packing"}>Packing Confirmation</Link>,
      //   key: "/production/packing",
      //   to: "/production/packing",
      //   allowedpermissions: [
      //     PACKING_VIEW_PERMISSION,
      //     PACKING_CREATE_PERMISSION,
      //     PACKING_EDIT_PERMISSION,
      //     PACKING_DELETE_PERMISSION,
      //   ],
      // },
      // {
      //   label: <Link to={"/production/packing/packing-entry"}>Packing</Link>,
      //   key: "/production/packing/packing-entry",
      //   to: "/production/packing/packing-entry",
      //   allowedpermissions: [
      //     PACKING_VIEW_PERMISSION,
      //     PACKING_CREATE_PERMISSION,
      //     PACKING_EDIT_PERMISSION,
      //     PACKING_DELETE_PERMISSION,
      //   ],
      // },
      // {
      //   label: <Link to={"/production/daily-line-target"}>Daily Line Target</Link>,
      //   key: "/production/daily-line-target",
      //   to: "/production/daily-line-target",
      //   allowedpermissions: [
      //     DAILY_LINE_TARGET_VIEW_PERMISSION,
      //     DAILY_LINE_TARGET_CREATE_PERMISSION,
      //     DAILY_LINE_TARGET_EDIT_PERMISSION,
      //     DAILY_LINE_TARGET_DELETE_PERMISSION,
      //   ],
      // },
      {
        label: (
          <Link to={"/production/fabric-accessories-auto-reconciliation"}>
            Fabric and Accessories Report
          </Link>
        ),
        key: "/production/fabric-accessories-auto-reconciliation",
        to: "/production/fabric-accessories-auto-reconciliation",
        allowedpermissions: [FABRIC_ACCESSORIES_AUTO_RECONCILIATION_VIEW_PERMISSION],
      },
      {
        label: <Link to={"/production/post-cutting-process"}>Embroidery, Printing, Smocking and Pintuck</Link>,
        key: "/production/post-cutting-process",
        to: "/production/post-cutting-process",
        allowedpermissions: [EMBROIDERY_PRINTING_SMOCKING_PINTUCK_VIEW_PERMISSION],
      },
      {
        label: <Link to={"/production/post-sewing-process"}>Washing and Snap Button</Link>,
        key: "/production/post-sewing-process",
        to: "/production/post-sewing-process",
        allowedpermissions: [WASHING_SNAP_BUTTON_VIEW_PERMISSION],
      },
      {
        label: <Link to={"/production/store-requisition"}>Store Requisition</Link>,
        key: "/production/store-requisition",
        to: "/production/store-requisition",
        allowedpermissions: [
          STORE_REQUISITION_VIEW_PERMISSION,
          STORE_REQUISITION_CREATE_PERMISSION,
          STORE_REQUISITION_EDIT_PERMISSION,
          STORE_REQUISITION_DELETE_PERMISSION,
        ],
      },
    ],
  },
  // {
  //   icon: <DeliveredProcedureOutlined />,
  //   label: "Forwarding",
  //   key: "/forwarding",
  //   children: [
  //     {
  //       label: <Link to={"/forwarding/store-shipment-info"}>Shipment</Link>,
  //       key: "/forwarding/store-shipment-info",
  //       to: "/shipment",
  //       allowedpermissions: [
  //         SHIPPING_VIEW_PERMISSION,
  //         SHIPPING_CREATE_PERMISSION,
  //         SHIPPING_EDIT_PERMISSION,
  //         SHIPPING_DELETE_PERMISSION,
  //       ],
  //     },
  //   ],
  // },
  {
    icon: <FileDoneOutlined />,
    label: "Reports",
    key: "/report",
    children: [
      {
        label: <Link to={"/report/report-fabric-reconciliation"}>Fabric Reconciliation</Link>,
        key: "/report/report-fabric-reconciliation",
        to: "/report-fabric-reconciliation",
        allowedpermissions: [
          FABRIC_REPORT_VIEW_PERMISSION,
          FABRIC_REPORT_GENERATE_PERMISSION,
          FABRIC_REPORT_DELETE_PERMISSION,
        ],
      },
      {
        label: <Link to={"/report/report-production-tracking"}>Production Tracking</Link>,
        key: "/report/report-production-tracking",
        to: "/report-production-tracking",
        allowedpermissions: [
          PRODUCT_TRACK_REPORT_VIEW_PERMISSION,
          PRODUCT_TRACK_REPORT_GENERATE_PERMISSION,
          PRODUCT_TRACK_REPORT_DELETE_PERMISSION,
        ],
      },
      {
        label: <Link to={"/report/report-production-details"}>Production Details</Link>,
        key: "/report/report-production-details",
        to: "/report-production-details",
        allowedpermissions: [PRODUCT_DETAIL_REPORT_GENERATE_PERMISSION, PRODUCT_DETAIL_REPORT_DELETE_PERMISSION],
      },
      // {
      //   label: <Link to={"/report/report-cost-sheet"}>Cost Sheet</Link>,
      //   key: "/report/report-cost-sheet",
      //   to: "/report-cost-sheet",
      //   allowedpermissions: [
      //     COST_SHEET_REPORT_VIEW_PERMISSION,
      //     COST_SHEET_REPORT_GENERATE_PERMISSION,
      //     COST_SHEET_REPORT_DELETE_PERMISSION,
      //   ],
      // },
      {
        label: <Link to={"/report/report-inventory-details"}>Inventory Details</Link>,
        key: "/report/report-inventory-details",
        to: "/report-inventory-details",
        allowedpermissions: [
          INVENTORY_DETAIL_REPORT_VIEW_PERMISSION,
          INVENTORY_DETAIL_REPORT_GENERATE_PERMISSION,
          INVENTORY_DETAIL_REPORT_DELETE_PERMISSION,
        ],
      },
      {
        label: <Link to={"/report/report-inventory-mrr"}>Supplier Wise MRR Inventory</Link>,
        key: "/report/report-inventory-mrr",
        to: "/report-inventory-mrr",
        allowedpermissions: [
          INVENTORY_MRR_REPORT_VIEW_PERMISSION,
          GENERATE_MRR_REPORT_VIEW_PERMISSION,
          DELETE_MRR_REPORT_VIEW_PERMISSION,
        ],
      },
      {
        label: <Link to={"/report/report-packing"}>Packing Report</Link>,
        key: "/report/report-packing",
        to: "/report-packing",
        allowedpermissions: [PACKING_LIST_REPORT_VIEW_PERMISSION],
      },
      {
        label: <Link to={"/report/buyer-report-packing"}>Buyer Packing Report</Link>,
        key: "/report/buyer-report-packing",
        to: "/buyer-report-packing",
        allowedpermissions: [PACKING_LIST_REPORT_VIEW_PERMISSION],
      },
      {
        label: <Link to={"/report/pi-report"}>PI Report</Link>,
        key: "/report/pi-report",
        to: "/pi-report",
        allowedpermissions: [PI_REPORT_VIEW_PERMISSION],
      },
      {
        label: <Link to={"/report/hourly-production"}>Hourly Production</Link>,
        key: "/report/hourly-production",
        to: "/hourly-production",
        allowedpermissions: [HOURLY_PRODUCTION_VIEW_PERMISSION],
      },
      {
        label: <Link to={"/report/hourly-production-detail-report"}>Hourly Production Detail</Link>,
        key: "/report/hourly-production-detail-report",
        to: "/hourly-production-detail-report",
        allowedpermissions: [HOURLY_PRODUCTION_VIEW_PERMISSION],
      },
      {
        label: <Link to={"/report/report-bolt-seal"}>Bolt Seal</Link>,
        key: "/report/report-bolt-seal",
        to: "/report/report-bolt-seal",
        allowedpermissions: [BOLT_SEAL_LOG_REPORT_PERMISSION],
      },
      {
        label: <Link to={"/report/report-post-costing"}>Post Costing</Link>,
        key: "/report/report-post-costing",
        to: "/report/report-post-costing",
        allowedpermissions: [POST_COSTING_REPORT_GENERATE_PERMISSION],
      },
      {
        label: <Link to={"/report/report-osr"}>OSR</Link>,
        key: "/report/report-osr",
        to: "/report-osr",
        allowedpermissions: [OSR_REPORT_GENERATE_PERMISSION],
      },
      {
        label: <Link to={"/report/report-sewing-and-folding"}>Sewing & Folding</Link>,
        key: "/report/report-sewing-and-folding",
        to: "/report-sewing-and-folding",
        allowedpermissions: [SEWING_FOLDING_REPORT_GENERATE_PERMISSION],
      },
      {
        label: <Link to={"/report/report-operator-absinthium"}>Absenteeism Report</Link>,
        key: "/report/report-operator-absinthium",
        to: "/report-operator-absinthium",
        allowedpermissions: [ABSINTHIUM_REPORT_GENERATE_PERMISSION],
      },
      {
        label: (
          <Link to={"/report/absenteeism-informed-reason"}>
            Absenteeism Informed Reason
          </Link>
        ),
        key: "/report/absenteeism-informed-reason",
        to: "/report/absenteeism-informed-reason",
        allowedpermissions: [
          ABSENTEEISM_INFORMED_REASON_REPORT_GENERATE_PERMISSION,
          ABSINTHIUM_REPORT_GENERATE_PERMISSION,
        ],
      },
      {
        label: <Link to={"/report/sales-contract-pos"}>Sales Contract POS</Link>,
        key: "/report/sales-contract-pos",
        to: "/report/sales-contract-pos",
        allowedpermissions: [VIEW_ALL_ACTIVE_POS_PERMISSION],
      },
      {
        label: <Link to={"/report/supplier-wise-item-price-report"}>Item Price</Link>,
        key: "/report/supplier-wise-item-price-report",
        to: "/report/supplier-wise-item-price-report",
        allowedpermissions: [SUPPLIER_WISE_ITEM_PRICE_REPORT_VIEW_PERMISSION],
      },
      {
        label: <Link to={"/report/sales-contract-cost"}>Sales Contract Cost</Link>,
        key: "/report/sales-contract-cost",
        to: "/report/sales-contract-cost",
        allowedpermissions: [SALES_CONTRACT_COSTING_REPORT],
      },
    ],
  },
  {
    icon: <PoundOutlined />,
    label: "Cost Of Making",
    key: "/cost-of-making",
    children: [
      {
        label: <Link to={"/cost-of-making/expense-calculation"}>Expense Data Calculation</Link>,
        key: "/cost-of-making/expense-calculation",
        to: "/cm-expense-calculation",
        allowedpermissions: [COST_OF_MAKING_LIST, COST_OF_MAKING_CREATE, COST_OF_MAKING_EDIT, COST_OF_MAKING_DELETE],
      },
      {
        label: <Link to={"/cost-of-making/default-data"}>Default Data</Link>,
        key: "/cost-of-making/default-data",
        to: "/cm-default-data",
        allowedpermissions: [COST_OF_MAKING_LIST, COST_OF_MAKING_CREATE, COST_OF_MAKING_EDIT, COST_OF_MAKING_DELETE],
      },
    ],
  },
  {
    icon: <ExportOutlined />,
    label: "Export",
    key: "/export",
    children: [
      {
        label: <Link to="/export/sales-contract">Sales Contract / Master LC (Commercial)</Link>,
        key: "/export/sales-contract",
        to: "/export/sales-contract",
        breadcrumbname: "Sales Contract",
        allowedpermissions: [
          SALES_CONTRACT_COMMERCIAL_VIEW_PERMISSION,
          SALES_CONTRACT_COMMERCIAL_CREATE_PERMISSION,
          SALES_CONTRACT_COMMERCIAL_EDIT_PERMISSION,
          SALES_CONTRACT_COMMERCIAL_DELETE_PERMISSION,
        ],
      },
      {
        label: <Link to="/export/export-details">Export Details</Link>,
        key: "/export/export-details",
        to: "/export/export-details",
        breadcrumbname: "Export Details",
        allowedpermissions: [
          EXPORT_DETAILS_VIEW_PERMISSION,
          EXPORT_DETAILS_CREATE_PERMISSION,
          EXPORT_DETAILS_EDIT_PERMISSION,
          EXPORT_DETAILS_DELETE_PERMISSION,
        ],
      },
      {
        label: <Link to="/export/submission-realization">Submission Realization</Link>,
        key: "/export/submission-realization",
        to: "/export/submission-realization",
        breadcrumbname: "Submission Realization",
        allowedpermissions: [
          SUBMISSION_REALIZATION_VIEW_PERMISSION,
          SUBMISSION_REALIZATION_CREATE_PERMISSION,
          SUBMISSION_REALIZATION_EDIT_PERMISSION,
          SUBMISSION_REALIZATION_DELETE_PERMISSION,
        ],
      },
      {
        label: <Link to="/export/commercial-packing-requirement">Commercial Packing Requirement</Link>,
        key: "/export/commercial-packing-requirement",
        to: "/export/commercial-packing-requirement",
        breadcrumbname: "Commercial Packing Requirement",
        allowedpermissions: [
          COMMERCIAL_PACKING_REQUIREMENT_VIEW_PERMISSION,
          COMMERCIAL_PACKING_REQUIREMENT_EDIT_PERMISSION,
        ],
      },
    ],
  },
  {
    icon: <ImportOutlined />,
    label: "Import",
    key: "/import",
    allowedpermissions: [IMPORT_MENU_VIEW_PERMISSION],
    children: [
      {
        label: <Link to="/import/b2blc">Import LC - BTB LC</Link>,
        key: "/import/b2blc",
        to: "/import/b2blc",
        breadcrumbname: "Import LC - BTB LC",
        allowedpermissions: [
          B2BLC_VIEW_PERMISSION,
          B2BLC_CREATE_PERMISSION,
          B2BLC_EDIT_PERMISSION,
          B2BLC_DELETE_PERMISSION,
        ],
      },
      {
        label: "Import Shipment Status",
        key: "/import/details",
        to: "/import/details",
        breadcrumbname: "Sales Contract",
        allowedpermissions: [
          DAILY_IMPORT_POSITION_VIEW_PERMISSION,
          DAILY_IMPORT_POSITION_CREATE_PERMISSION,
          DAILY_IMPORT_POSITION_EDIT_PERMISSION,
          DAILY_IMPORT_POSITION_DELETE_PERMISSION,
        ],
        children: [
          {
            label: <Link to="/import/details/0">Foreign</Link>,
            key: "/import/details/0",
            to: "/import/details/0",
            breadcrumbname: "Foreign",
          },
          {
            label: <Link to="/import/details/1">Local</Link>,
            key: "/import/details/1",
            to: "/import/details/1",
            breadcrumbname: "Local",
          },
          {
            label: <Link to="/import/details/2">EPZ</Link>,
            key: "/import/details/2",
            to: "/import/details/2",
            breadcrumbname: "EPZ",
          },
        ],
      },
      {
        label: <Link to="/import/acceptance-details">Import Acceptance Details</Link>,
        key: "/import/acceptance-details",
        to: "/import/acceptance-details",
        breadcrumbname: "Sales Contract",
        allowedpermissions: [
          IMPORT_ACCEPTANCE_DETAIL_VIEW_PERMISSION,
          IMPORT_ACCEPTANCE_DETAIL_CREATE_PERMISSION,
          IMPORT_ACCEPTANCE_DETAIL_EDIT_PERMISSION,
          IMPORT_ACCEPTANCE_DETAIL_DELETE_PERMISSION,
        ],
      },
    ],
  },
  {
    icon: <CarryOutOutlined />,
    label: "Import Customs Clearance",
    key: "/import-customs-clearance",
    children: [
      {
        label: (
          <Link to="/import-customs-clearance/noting-assessment-examination">Noting Assessment and Examinations</Link>
        ),
        key: "/import-customs-clearance/noting-assessment-examination",
        to: "/import-customs-clearance/noting-assessment-examination",
        breadcrumbname: "Noting Assessment and Examinations",
        allowedpermissions: [
          NOTING_ASSESSMENT_VIEW_PERMISSION,
          NOTING_ASSESSMENT_CREATE_PERMISSION,
          NOTING_ASSESSMENT_EDIT_PERMISSION,
          NOTING_ASSESSMENT_DELETE_PERMISSION,
        ],
      },
      {
        label: <Link to="/import/vehicle-information">Vehicle Information</Link>,
        key: "/import/vehicle-information",
        to: "/import/vehicle-information",
        breadcrumbname: "Vehicle Information",
        allowedpermissions: [
          GOODS_DELIVERY_VIEW_PERMISSION,
          GOODS_DELIVERY_CREATE_PERMISSION,
          GOODS_DELIVERY_EDIT_PERMISSION,
          GOODS_DELIVERY_DELETE_PERMISSION,
        ],
      },
      {
        label: "Import Shipment",
        key: "/import/shipment",
        breadcrumbname: "Import Shipment",
        allowedpermissions: [
          GOODS_DELIVERY_VIEW_PERMISSION,
          GOODS_DELIVERY_CREATE_PERMISSION,
          GOODS_DELIVERY_EDIT_PERMISSION,
          GOODS_DELIVERY_DELETE_PERMISSION,
          IMPORT_VEHICLE_ASSIGNMENT_VIEW_PERMISSION,
          IMPORT_VEHICLE_ASSIGNMENT_STORE_PERMISSION,
          IMPORT_VEHICLE_ASSIGNMENT_EDIT_PERMISSION,
          IMPORT_VEHICLE_ASSIGNMENT_DELETE_PERMISSION,
        ],
        children: [
          {
            label: <Link to="/import/goods-delivery">Single Vehicle</Link>,
            key: "/import/goods-delivery",
            to: "/import/goods-delivery",
            breadcrumbname: "Import Shipment for Single Vehicle",
            allowedpermissions: [
              GOODS_DELIVERY_VIEW_PERMISSION,
              GOODS_DELIVERY_CREATE_PERMISSION,
              GOODS_DELIVERY_EDIT_PERMISSION,
              GOODS_DELIVERY_DELETE_PERMISSION,
            ],
          },
          {
            label: <Link to="/import/vehicle-assignment">Multiple Vehicle</Link>,
            key: "/import/vehicle-assignment",
            to: "/import/vehicle-assignment",
            breadcrumbname: "Import Shipment for Multiple Vehicle",
            allowedpermissions: [
              IMPORT_VEHICLE_ASSIGNMENT_VIEW_PERMISSION,
              IMPORT_VEHICLE_ASSIGNMENT_STORE_PERMISSION,
              IMPORT_VEHICLE_ASSIGNMENT_EDIT_PERMISSION,
              IMPORT_VEHICLE_ASSIGNMENT_DELETE_PERMISSION,
            ],
          },
        ],
      },
      {
        label: "Export Shipment",
        key: "/export/shipment",
        breadcrumbname: "Export Shipment",
        allowedpermissions: [
          EXPORT_SHIPMENT_VIEW_PERMISSION,
          EXPORT_SHIPMENT_CREATE_PERMISSION,
          EXPORT_SHIPMENT_EDIT_PERMISSION,
          EXPORT_SHIPMENT_DELETE_PERMISSION,
          EXPORT_VEHICLE_ASSIGNMENT_VIEW_PERMISSION,
          EXPORT_VEHICLE_ASSIGNMENT_STORE_PERMISSION,
          EXPORT_VEHICLE_ASSIGNMENT_EDIT_PERMISSION,
          EXPORT_VEHICLE_ASSIGNMENT_DELETE_PERMISSION,
        ],
        children: [
          {
            label: <Link to="/export/goods-delivery">Single Vehicle</Link>,
            key: "/export/goods-delivery",
            to: "/export/goods-delivery",
            breadcrumbname: "Export Shipment for Single Vehicle",
            allowedpermissions: [
              EXPORT_SHIPMENT_VIEW_PERMISSION,
              EXPORT_SHIPMENT_CREATE_PERMISSION,
              EXPORT_SHIPMENT_EDIT_PERMISSION,
              EXPORT_SHIPMENT_DELETE_PERMISSION,
            ],
          },
          {
            label: <Link to="/export/vehicle-assignment">Multiple Vehicle</Link>,
            key: "/export/vehicle-assignment",
            to: "/export/vehicle-assignment",
            breadcrumbname: "Export Shipment for Multiple Vehicle",
            allowedpermissions: [
              EXPORT_VEHICLE_ASSIGNMENT_VIEW_PERMISSION,
              EXPORT_VEHICLE_ASSIGNMENT_STORE_PERMISSION,
              EXPORT_VEHICLE_ASSIGNMENT_EDIT_PERMISSION,
              EXPORT_VEHICLE_ASSIGNMENT_DELETE_PERMISSION,
            ],
          },
        ],
      },
      {
        label: "Local",
        key: "/local",
        breadcrumbname: "Local",
        allowedpermissions: [
          LOCAL_OUTGOING_SHIPMENT_VIEW_PERMISSION,
          LOCAL_OUTGOING_SHIPMENT_CREATE_PERMISSION,
          LOCAL_OUTGOING_SHIPMENT_EDIT_PERMISSION,
          LOCAL_OUTGOING_SHIPMENT_DELETE_PERMISSION,
          LOCAL_INCOMING_SHIPMENT_VIEW_PERMISSION,
          LOCAL_INCOMING_SHIPMENT_CREATE_PERMISSION,
          LOCAL_INCOMING_SHIPMENT_EDIT_PERMISSION,
          LOCAL_INCOMING_SHIPMENT_DELETE_PERMISSION,
        ],
        children: [
          {
            label: <Link to="/local/outgoing">Outgoing</Link>,
            key: "/local/outgoing",
            to: "/local/outgoing",
            breadcrumbname: "Local Outgoing",
            allowedpermissions: [
              LOCAL_OUTGOING_SHIPMENT_VIEW_PERMISSION,
              LOCAL_OUTGOING_SHIPMENT_CREATE_PERMISSION,
              LOCAL_OUTGOING_SHIPMENT_EDIT_PERMISSION,
              LOCAL_OUTGOING_SHIPMENT_DELETE_PERMISSION,
            ],
          },
          {
            label: <Link to="/local/incoming">Incoming</Link>,
            key: "/local/incoming",
            to: "/local/incoming",
            breadcrumbname: "Local Incoming",
            allowedpermissions: [
              LOCAL_INCOMING_SHIPMENT_VIEW_PERMISSION,
              LOCAL_INCOMING_SHIPMENT_CREATE_PERMISSION,
              LOCAL_INCOMING_SHIPMENT_EDIT_PERMISSION,
              LOCAL_INCOMING_SHIPMENT_DELETE_PERMISSION,
            ],
          },
        ],
      },
    ],
  },
  {
    icon: <CloseSquareOutlined />,
    label: "Ex-Factory",
    key: "/ex-factory",
    children: [
      // {
      //   label: (
      //     <Link to="/ex-factory/security-bolt-seal-log">
      //       Security Bolt Seal Log
      //     </Link>
      //   ),
      //   key: "/ex-factory/security-bolt-seal-log",
      //   to: "/ex-factory/security-bolt-seal-log",
      //   breadcrumbname: "Security Bolt Seal Log",
      //   allowedpermissions: [
      //     SECURITY_BOLT_VIEW_PERMISSION,
      //     SECURITY_BOLT_CREATE_PERMISSION,
      //     SECURITY_BOLT_EDIT_PERMISSION,
      //     SECURITY_BOLT_DELETE_PERMISSION,
      //   ],
      // },

      {
        label: <Link to="/ex-factory/vehicle-information">Vehicle Information</Link>,
        key: "/ex-factory/vehicle-information",
        to: "/ex-factory/vehicle-information",
        breadcrumbname: "Vehicle Information",
        allowedpermissions: [
          DRIVER_VEHICLE_INFO_VIEW_PERMISSION,
          DRIVER_VEHICLE_INFO_CREATE_PERMISSION,
          DRIVER_VEHICLE_INFO_EDIT_PERMISSION,
          DRIVER_VEHICLE_INFO_DELETE_PERMISSION,
          DRIVER_VEHICLE_INFO_DISPATCH_TIME_PERMISSION,
        ],
      },
      {
        label: <Link to="/ex-factory/driver-information">Driver Information</Link>,
        key: "/ex-factory/driver-information",
        to: "/ex-factory/driver-information",
        breadcrumbname: "Driver Information",
        allowedpermissions: [
          DRIVER_VEHICLE_INFO_VIEW_PERMISSION,
          DRIVER_VEHICLE_INFO_CREATE_PERMISSION,
          DRIVER_VEHICLE_INFO_EDIT_PERMISSION,
          DRIVER_VEHICLE_INFO_DELETE_PERMISSION,
          DRIVER_VEHICLE_INFO_DISPATCH_TIME_PERMISSION,
        ],
      },
      {
        label: <Link to="/ex-factory/bolt-seal-usage">Bolt Seal Usage</Link>,
        key: "/ex-factory/bolt-seal-usage",
        to: "/ex-factory/bolt-seal-usage",
        breadcrumbname: "Bolt Seal Usage",
        allowedpermissions: [
          BOLT_SEAL_LOG_CREATE_PERMISSION,
          BOLT_SEAL_LOG_EDIT_PERMISSION,
          BOLT_SEAL_LOG_VIEW_PERMISSION,
          BOLT_SEAL_LOG_DELETE_PERMISSION,
        ],
      },
    ],
  },
  // {
  //   icon: <CiOutlined />,
  //   label: "Export Customs Clearance",
  //   key: "/export-customs-clearance",
  //   children: [
  //     {
  //       label: <Link to="/export-customs-clearance/shipment-handover">Shipment Handover</Link>,
  //       key: "/export-customs-clearance/shipment-handover",
  //       to: "/export-customs-clearance/shipment-handover",
  //       breadcrumbname: "Shipment Handover",
  //       allowedpermissions: [
  //         SHIPMENT_HANDOVER_VIEW_PERMISSION,
  //         SHIPMENT_HANDOVER_CREATE_PERMISSION,
  //         SHIPMENT_HANDOVER_EDIT_PERMISSION,
  //         SHIPMENT_HANDOVER_DELETE_PERMISSION,
  //       ],
  //     },
  //   ],
  // },
  {
    icon: <DiffOutlined />,
    label: <Link to="/import-files">Import Files</Link>,
    key: "/import-files",
    to: "/import-files",
    breadcrumbname: "Import Files",
    allowedpermissions: [
      UPLOAD_BUYER_PERMISSION,
      UPLOAD_BRAND_PERMISSION,
      UPLOAD_BUYING_OFFICE_PERMISSION,
      UPLOAD_BANK_PERMISSION,
      UPLOAD_BRANCH_PERMISSION,
      UPLOAD_MERCHANDISER_PERMISSION,
      UPLOAD_STYLE_PERMISSION,
      UPLOAD_SUBSTYLE_PERMISSION,
      UPLOAD_SALES_CONTRACT_PERMISSION,
      UPLOAD_SUPPLIER_PERMISSION,
      UPLOAD_COLOR_PERMISSION,
      UPLOAD_SIZE_PERMISSION,
      UPLOAD_BOM_PERMISSION,
      UPLOAD_PO_PERMISSION,
    ],
  },
  {
    icon: <BellOutlined />,
    label: <Link to="/notifications">Notifications</Link>,
    key: "/notifications",
    to: "/notifications",
    breadcrumbname: "Notifications",
    allowedpermissions: [NOTIFICATION_VIEW_PERMISSION],
  },
  // {
  //   icon: <LoginOutlined />,
  //   label: "Activity Log",
  //   key: "/activity-log",
  //   children: [
  //     {
  //       label: <Link to="/activity-log/all">All Activity</Link>,
  //       key: "/activity-log/all",
  //       to: "/activity-log/all",
  //       breadcrumbname: "All Activity",
  //       allowedpermissions: [ACTIVITY_LOG_VIEW_PERMISSION],
  //     },
  //   ],
  // },
  {
    icon: <AppstoreAddOutlined />,
    label: "Digitalization",
    key: "/digitalization",
    allowedpermissions: [DIGITALIZATION_MENU_VIEW_PERMISSION],
    children: [
      {
        label: <Link to="/digitalization/app-dashboard">App Dashboard</Link>,
        key: "/digitalization/app-dashboard",
        to: "/digitalization/app-dashboard",
        breadcrumbname: "App Dashboard",
        allowedpermissions: [APP_DASHBOARD_VIEW_PERMISSION],
      },

      {
        label: <Link to="/digitalization/supervisor-checklist">Supervisor Checklist</Link>,
        key: "/digitalization/supervisor-checklist",
        to: "/digitalization/supervisor-checklist",
        breadcrumbname: "Supervisor Checklist",
        allowedpermissions: [
          SUPERVISOR_CHECKLIST_CREATE_PERMISSION,
          SUPERVISOR_CHECKLIST_EDIT_PERMISSION,
          SUPERVISOR_CHECKLIST_VIEW_PERMISSION,
          SUPERVISOR_CHECKLIST_DELETE_PERMISSION,
        ],
      },
      {
        label: <Link to="/digitalization/operator-absenteeism">Operator Absenteeism</Link>,
        key: "/digitalization/operator-absenteeism",
        to: "/digitalization/operator-absenteeism",
        breadcrumbname: "Operator Absenteeism",
        allowedpermissions: [DIGITALIZATION_ABSENTEEISM_VIEW_PERMISSION],
      },
      {
        label: <Link to="/digitalization/production-defect">Production Defect</Link>,
        key: "/digitalization/production-defect",
        to: "/digitalization/production-defect",
        breadcrumbname: "Production Defect",
        allowedpermissions: [DIGITALIZATION_DEFECT_VIEW_PERMISSION],
      },
      {
        label: <Link to="/digitalization/hourly-production-record">Hourly Production Record</Link>,
        key: "/digitalization/hourly-production-record",
        to: "/digitalization/hourly-production-record",
        breadcrumbname: "Hourly Production Record",
        allowedpermissions: [HOURLY_PRODUCTION_VIEW_PERMISSION],
      },
      {
        label: <Link to="/digitalization/garments-tracking">Garments Tracking</Link>,
        key: "/digitalization/garments-tracking",
        to: "/digitalization/garments-tracking",
        breadcrumbname: "Garments Tracking",
        allowedpermissions: [GARMENTS_TRACKING_VIEW_PERMISSION],
      },
      {
        label: <Link to="/digitalization/daily-line-plan">Line wise Operator assignment</Link>,
        key: "/digitalization/daily-line-plan",
        to: "/digitalization/daily-line-plan",
        breadcrumbname: "Line wise Operator assignment",
        allowedpermissions: [DAILY_LINE_PLAN_VIEW_PERMISSION],
      },
      {
        label: <Link to="/digitalization/daily-finishing-line-plan">Line wise Finishing assignment</Link>,
        key: "/digitalization/daily-finishing-line-plan",
        to: "/digitalization/daily-finishing-line-plan",
        breadcrumbname: "Line wise Finishing assignment",
        allowedpermissions: [NO_PERMISSION_REQUIRED],
      },
      {
        label: <Link to="/digitalization/folding-requirement">Assort Wise Folding Requirement</Link>,
        key: "/digitalization/folding-requirement",
        to: "/digitalization/folding-requirement",
        breadcrumbname: "Folding Requirement Management",
        allowedpermissions: [
          FOLDING_REQUIREMENT_DELETE_PERMISSION,
          FOLDING_REQUIREMENT_VIEW_PERMISSION,
          FOLDING_REQUIREMENT_CREATE_PERMISSION,
          FOLDING_REQUIREMENT_EDIT_PERMISSION,
        ],
      },
      {
        label: "Settings",
        key: "/Settings",
        to: "Settings",
        breadcrumbname: "Settings",
        allowedpermissions: [DIGITALIZATION_SETTINGS_VIEW_PERMISSION],
        children: [
          {
            label: <Link to="/digitalization/app-role">Menu</Link>,
            key: "/digitalization/app-role",
            to: "/digitalization/app-role",
            breadcrumbname: "Menu Setting",
            allowedpermissions: [DIGITALIZATION_SETTINGS_VIEW_PERMISSION],
          },
          {
            label: <Link to="/digitalization/user-line-assign">User Line Assign</Link>,
            key: "/digitalization/user-line-assign",
            to: "/digitalization/user-line-assign",
            breadcrumbname: "User Line Assign",
            allowedpermissions: [DIGITALIZATION_SETTINGS_VIEW_PERMISSION],
          },
          {
            label: <Link to="/digitalization/user-list">User</Link>,
            key: "/digitalization/user-list",
            to: "/digitalization/user-list",
            breadcrumbname: "User List",
            allowedpermissions: [DIGITALIZATION_SETTINGS_VIEW_PERMISSION],
          },
          {
            label: <Link to="/digitalization/hour">Hour</Link>,
            key: "/digitalization/hour",
            to: "/digitalization/hour",
            breadcrumbname: "Hour",
            allowedpermissions: [DIGITALIZATION_SETTINGS_VIEW_PERMISSION],
          },
          {
            label: <Link to="/digitalization/hourly-production-record-hour">HPR Hour</Link>,
            key: "/digitalization/hourly-production-record-hour",
            to: "/digitalization/hourly-production-record-hour",
            breadcrumbname: "Hourly Production Record Hour",
            allowedpermissions: [DIGITALIZATION_SETTINGS_VIEW_PERMISSION],
          },
          {
            label: <Link to={"/digitalization/finishing-lines"}>Finishing Line</Link>,
            key: "/digitalization/finishing-lines",
            to: "/digitalization/finishing-lines",
            breadcrumbname: "Finishing Line",
            allowedpermissions: [
              FINISHING_LINE_VIEW_PERMISSION,
              FINISHING_LINE_CREATE_PERMISSION,
              FINISHING_LINE_EDIT_PERMISSION,
              FINISHING_LINE_DELETE_PERMISSION,
            ],
          },
          {
            label: <Link to={"/digitalization/finishing-lines-mapping"}>Finishing Line Mapping</Link>,
            key: "/digitalization/finishing-lines-mapping",
            to: "/digitalization/finishing-lines-mapping",
            breadcrumbname: "Finishing Line Mapping",
            allowedpermissions: [FINISHING_LINE_MAPPING_VIEW_PERMISSION, FINISHING_LINE_MAPPING_CREATE_PERMISSION],
          },
          {
            label: <Link to="/digitalization/garments-tracking-hourly-target">Garments Tracking Hourly Target</Link>,
            key: "/digitalization/garments-tracking-hourly-target",
            to: "/digitalization/garments-tracking-hourly-target",
            breadcrumbname: "Garments Tracking Hourly Target",
            allowedpermissions: [NO_PERMISSION_REQUIRED],
          },
        ],
      },
      {
        label: "Defect",
        key: "/defect",
        to: "/defect",
        breadcrumbname: "Defect",
        allowedpermissions: [DIGITALIZATION_DEFECT_VIEW_PERMISSION],
        children: [
          {
            label: <Link to="/digitalization/defect/category">Category</Link>,
            key: "/digitalization/defect/category",
            to: "/digitalization/defect/category",
            breadcrumbname: "Category",
            allowedpermissions: [DIGITALIZATION_DEFECT_VIEW_PERMISSION],
          },
          {
            label: <Link to="/digitalization/defect/reason">Reason</Link>,
            key: "/digitalization/defect/reason",
            to: "/digitalization/defect/reason",
            breadcrumbname: "Reason",
            allowedpermissions: [DIGITALIZATION_DEFECT_VIEW_PERMISSION],
          },
          {
            label: <Link to="/digitalization/defect/responsible">Responsible</Link>,
            key: "/digitalization/defect/responsible",
            to: "/digitalization/defect/responsible",
            breadcrumbname: "Responsible",
            allowedpermissions: [DIGITALIZATION_DEFECT_VIEW_PERMISSION],
          },
          {
            label: <Link to="/digitalization/defect/recommendation">Recommendation</Link>,
            key: "/digitalization/defect/recommendation",
            to: "/digitalization/defect/recommendation",
            breadcrumbname: "Recommendation",
            allowedpermissions: [DIGITALIZATION_DEFECT_VIEW_PERMISSION],
          },
          {
            label: <Link to="/digitalization/defect/category-mapping">Category Mapping</Link>,
            key: "/digitalization/defect/category-mapping",
            to: "/digitalization/defect/category-mapping",
            breadcrumbname: "Category-mapping",
            allowedpermissions: [DIGITALIZATION_DEFECT_VIEW_PERMISSION],
          },
          {
            label: <Link to="/digitalization/defect/line-and-section-mapping">Line & Section wise Mapping</Link>,
            key: "digitalization/defect/line-and-section-mapping",
            to: "digitalization/defect/line-and-section-mapping",
            breadcrumbname: "Line-and-section-mapping",
            allowedpermissions: [DIGITALIZATION_DEFECT_VIEW_PERMISSION],
          },
        ],
      },
      {
        label: "Report",
        key: "/report",
        to: "/report",
        breadcrumbname: "Report",
        allowedpermissions: [NO_PERMISSION_REQUIRED],
        children: [
          {
            label: <Link to="/digitalization/operator-efficiency">Operator Efficiency</Link>,
            key: "/digitalization/operator-efficiency",
            to: "/digitalization/operator-efficiency",
            breadcrumbname: "Operator Efficiency",
            allowedpermissions: [NO_PERMISSION_REQUIRED],
          },
          {
            label: <Link to="/digitalization/line-wise-operator-hourly-report">Operator-wise Hourly Production</Link>,
            key: "/digitalization/line-wise-operator-hourly-report",
            to: "/digitalization/line-wise-operator-hourly-report",
            breadcrumbname: "Operator-wise Hourly Production",
            allowedpermissions: [NO_PERMISSION_REQUIRED],
          },
          {
            label: <Link to="/digitalization/line-wise-operation-hourly-report">Operation wise Hourly Production</Link>,
            key: "/digitalization/line-wise-operation-hourly-report",
            to: "/digitalization/line-wise-operation-hourly-report",
            breadcrumbname: "Operation wise Hourly Production",
            allowedpermissions: [NO_PERMISSION_REQUIRED],
          },
          {
            label: <Link to="/digitalization/line-wise-defects-dhu">Line Wise Defects & DHU</Link>,
            key: "/digitalization/line-wise-defects-dhu",
            to: "/digitalization/line-wise-defects-dhu",
            breadcrumbname: "Line Wise Defects & DHU",
            allowedpermissions: [LINE_WISE_CATEGORY_DEFECT_REPORT_VIEW_PERMISSION],
          },
          {
            label: <Link to="/digitalization/audit-report">Audit Report</Link>,
            key: "/digitalization/audit-report",
            to: "/digitalization/audit-report",
            breadcrumbname: "Audit Report",
            allowedpermissions: [CGL_AUDIT_REPORT_LIST_VIEW_PERMISSION],
          },
          {
            label: <Link to="/digitalization/qc-validation-report">QC Validation Report</Link>,
            key: "/digitalization/qc-validation-report",
            to: "/digitalization/qc-validation-report",
            breadcrumbname: "QC Validation Report",
            allowedpermissions: [QC_VALIDATION_REPORT_VIEW_PERMISSION],
          },
          {
            label: <Link to="/digitalization/sewing-line-defect">Sewing Line Defect</Link>,
            key: "/digitalization/sewing-line-defect",
            to: "/digitalization/sewing-line-defect",
            breadcrumbname: "Sewing Line Defect",
            allowedpermissions: [SEWING_LINE_DEFECT_REPORT_VIEW_PERMISSION],
          },
          {
            label: <Link to="/digitalization/sewing-line-defect-monthly">Sewing Line Defect (Monthly)</Link>,
            key: "/digitalization/sewing-line-defect-monthly",
            to: "/digitalization/sewing-line-defect-monthly",
            breadcrumbname: "Sewing Line Defect (Monthly)",
            allowedpermissions: [SEWING_LINE_DEFECT_MONTHLY_REPORT_VIEW_PERMISSION],
          },
        ],
      },
      {
        label: "PP and Buyer Inspection",
        key: "/pp-and-buyer-inspection",
        to: "/pp-and-buyer-inspection",
        breadcrumbname: "PP and Buyer Inspection",
        allowedpermissions: [PP_BUYER_INSPECTION_MENU_VIEW_PERMISSION],
        children: [
          {
            label: <Link to="/digitalization/pp-meeting-date">PP Meeting Date</Link>,
            key: "/digitalization/pp-meeting-date",
            to: "/digitalization/pp-meeting-date",
            breadcrumbname: "PP Meeting Date",
            allowedpermissions: [PP_BUYER_INSPECTION_MENU_VIEW_PERMISSION],
          },
          {
            label: <Link to="/digitalization/buyer-inspection-date">Buyer Inspection Date</Link>,
            key: "/digitalization/buyer-inspection-date",
            to: "/digitalization/buyer-inspection-date",
            breadcrumbname: "Buyer Inspection Date",
            allowedpermissions: [PP_BUYER_INSPECTION_MENU_VIEW_PERMISSION],
          },
          {
            label: <Link to="/digitalization/buyer-visit-date">Buyer Visit Date</Link>,
            key: "/digitalization/buyer-visit-date",
            to: "/digitalization/buyer-visit-date",
            breadcrumbname: "Buyer Visit Date",
            allowedpermissions: [PP_BUYER_INSPECTION_MENU_VIEW_PERMISSION],
          },
          {
            label: <Link to="/digitalization/audit-date">Audit Date</Link>,
            key: "/digitalization/audit-date",
            to: "/digitalization/audit-date",
            breadcrumbname: "Audit Date",
            allowedpermissions: [PP_BUYER_INSPECTION_MENU_VIEW_PERMISSION],
          },
          {
            label: <Link to="/digitalization/capacity-of-sample-team">Capacity of Sample Team</Link>,
            key: "/digitalization/capacity-of-sample-team",
            to: "/digitalization/capacity-of-sample-team",
            breadcrumbname: "Capacity of Sample Team",
            allowedpermissions: [PP_BUYER_INSPECTION_MENU_VIEW_PERMISSION],
          },
          {
            label: <Link to="/digitalization/fabric-loading-capacity-of-store">Fabric Loading Capacity of Store</Link>,
            key: "/digitalization/fabric-loading-capacity-of-store",
            to: "/digitalization/fabric-loading-capacity-of-store",
            breadcrumbname: "Fabric Loading Capacity of Store",
            allowedpermissions: [PP_BUYER_INSPECTION_MENU_VIEW_PERMISSION],
          },
          {
            label: <Link to="/digitalization/sample-requisitions">Sample Requisitions</Link>,
            key: "/digitalization/sample-requisitions",
            to: "/digitalization/sample-requisitions",
            breadcrumbname: "Sample Requisitions",
            allowedpermissions: [PP_BUYER_INSPECTION_MENU_VIEW_PERMISSION],
          },
          {
            label: <Link to="/digitalization/overtime-reasons">Overtime Reasons</Link>,
            key: "/digitalization/overtime-reasons",
            to: "/digitalization/overtime-reasons",
            breadcrumbname: "Overtime Reasons",
            allowedpermissions: [PP_BUYER_INSPECTION_MENU_VIEW_PERMISSION],
          },
          {
            label: <Link to="/digitalization/overtime-signals">Overtime Signals</Link>,
            key: "/digitalization/overtime-signals",
            to: "/digitalization/overtime-signals",
            breadcrumbname: "Overtime Signals",
            allowedpermissions: [PP_BUYER_INSPECTION_MENU_VIEW_PERMISSION],
          },
          {
            label: <Link to="/digitalization/sam-justification">Sam Justification</Link>,
            key: "/digitalization/sam-justification",
            to: "/digitalization/sam-justification",
            breadcrumbname: "Sam Justification",
            allowedpermissions: [PP_BUYER_INSPECTION_MENU_VIEW_PERMISSION],
          },
        ],
      },
      {
        label: "Checklist",
        key: "/checklist",
        to: "/checklist",
        breadcrumbname: "Checklist",
        allowedpermissions: [CHECKLIST_MENU_VIEW_PERMISSION],
        children: [
          {
            label: <Link to="/checklist/checklist-questions/list">Questions List</Link>,
            key: "/checklist/checklist-questions/list",
            to: "/checklist/checklist-questions/list",
            breadcrumbname: "Category",
            allowedpermissions: [CHECKLIST_MENU_VIEW_PERMISSION],
          },
        ],
      },
      {
        label: <Link to="/digitalization/buyer-wise-checklist">Buyer Wise Checklist</Link>,
        key: "/digitalization/buyer-wise-checklist",
        to: "/digitalization/buyer-wise-checklist",
        breadcrumbname: "Buyer Style Checklists",
        allowedpermissions: [BUYER_WISE_CHECKLIST_VIEW_PERMISSION],
      },
      {
        label: "Offline Sync Logs",
        key: "/offline-sync-logs",
        to: "/offline-sync-logs",
        breadcrumbname: "Offline Sync Logs",
        allowedpermissions: [APP_OFFLINE_SYNC_LOG_VIEW_PERMISSION],
        children: [
          {
            label: <Link to="/offline-sync-logs/failed-items">Failed Items</Link>,
            key: "/offline-sync-logs/failed-items",
            to: "/offline-sync-logs/failed-items",
            breadcrumbname: "Failed Items",
            allowedpermissions: [NO_PERMISSION_REQUIRED],
          },
        ],
      },
      {
        label: "Problem Remedy",
        key: "/problem-remedy",
        to: "/problem-remedy",
        breadcrumbname: "Problem Remedy",
        allowedpermissions: [PROBLEM_REMEDY_LOG_VIEW_PERMISSION],
        children: [
          {
            label: <Link to="/problem-remedy/remedy-log">Remedy Logs</Link>,
            key: "/problem-remedy/remedy-log",
            to: "/problem-remedy/remedy-log",
            breadcrumbname: "Remedy Logs",
            allowedpermissions: [PROBLEM_REMEDY_LOG_VIEW_PERMISSION],
          },
        ],
      },

      {
        label: "Finishing",
        key: "/Finishing",
        to: "/Finishing",
        breadcrumbname: "Finishing",
        allowedpermissions: [DIGITALIZATION_SETTINGS_VIEW_PERMISSION],
        children: [
          {
            label: <Link to="/digitalization/finishing/sewing-to-folding">Sewing to Folding</Link>,
            key: "/digitalization/finishing/sewing-to-folding",
            to: "/digitalization/finishing/sewing-to-folding",
            breadcrumbname: "Sewing to Folding",
            allowedpermissions: [
              GARMENT_RECEIVED_CREATE_PERMISSION,
              GARMENT_RECEIVED_VIEW_PERMISSION,
              GARMENT_RECEIVED_UPDATE_PERMISSION,
            ],
          },
          {
            label: <Link to="/digitalization/finishing/hourly-iron">Hourly Iron</Link>,
            key: "/digitalization/finishing/hourly-iron",
            to: "/digitalization/finishing/hourly-iron",
            breadcrumbname: "Hourly Iron",
            allowedpermissions: [
              HOURLY_IRON_VIEW_PERMISSION,
              HOURLY_IRON_CREATE_PERMISSION,
              HOURLY_IRON_EDIT_PERMISSION,
            ],
          },
          {
            label: <Link to="/digitalization/finishing/hourly-fold">Hourly Fold</Link>,
            key: "/digitalization/finishing/hourly-fold",
            to: "/digitalization/finishing/hourly-fold",
            breadcrumbname: "Hourly Fold",
            allowedpermissions: [
              HOURLY_FOLD_VIEW_PERMISSION,
              HOURLY_FOLD_CREATE_PERMISSION,
              HOURLY_FOLD_EDIT_PERMISSION,
            ],
          },
          {
            label: <Link to="/digitalization/finishing/hourly-poly">Hourly Poly</Link>,
            key: "/digitalization/finishing/hourly-poly",
            to: "/digitalization/finishing/hourly-poly",
            breadcrumbname: "Hourly Poly",
            allowedpermissions: [
              HOURLY_POLY_VIEW_PERMISSION,
              HOURLY_POLY_CREATE_PERMISSION,
              HOURLY_POLY_EDIT_PERMISSION,
            ],
          },
          {
            label: <Link to="/digitalization/finishing/mismatch-report">Mismatch Report</Link>,
            key: "/digitalization/finishing/mismatch-report",
            to: "/digitalization/finishing/mismatch-report",
            breadcrumbname: "Mismatch Report",
            allowedpermissions: [GARMENT_RECEIVED_VIEW_PERMISSION],
          },
        ],
      },
      {
        label: "Packing",
        key: "/Packing",
        to: "/Packing",
        breadcrumbname: "Packing",
        allowedpermissions: [FINISHING_GARMENT_RECEIVED_VIEW_PERMISSION],
        children: [
          {
            label: <Link to="/digitalization/packing/folding-to-packing">Folding To Packing</Link>,
            key: "/digitalization/packing/folding-to-packing",
            to: "/digitalization/packing/folding-to-packing",
            breadcrumbname: "Folding To Packing",
            allowedpermissions: [
              FINISHING_GARMENT_RECEIVED_CREATE_PERMISSION,
              FINISHING_GARMENT_RECEIVED_VIEW_PERMISSION,
              FINISHING_GARMENT_RECEIVED_UPDATE_PERMISSION,
            ],
          },
          {
            label: <Link to={"/digitalization/packing/confirmation"}>Packing Confirmation</Link>,
            key: "/digitalization/packing/confirmation",
            to: "/digitalization/packing/confirmation",
            allowedpermissions: [
              PACKING_VIEW_PERMISSION,
              PACKING_CREATE_PERMISSION,
              PACKING_EDIT_PERMISSION,
              PACKING_DELETE_PERMISSION,
            ],
          },
          {
            label: <Link to={"/digitalization/packing/assignment"}>Packing Assignment</Link>,
            key: "/digitalization/packing/assignment",
            to: "/digitalization/packing/assignment",
            allowedpermissions: [
              DAILY_PACKING_ASSIGNMENT_VIEW_PERMISSION,
              DAILY_PACKING_ASSIGNMENT_CREATE_PERMISSION,
              DAILY_PACKING_ASSIGNMENT_EDIT_PERMISSION,
              DAILY_PACKING_ASSIGNMENT_DELETE_PERMISSION,
            ],
          },
        ],
      },
      // Machine Maintenance
      {
        label: "Machine Maintenance",
        key: "/machine-maintenance",
        to: "/machine-maintenance",
        breadcrumbname: "Machine Maintenance",
        allowedpermissions: [NO_PERMISSION_REQUIRED],
        children: [
          {
            label: <Link to="#">Configurations</Link>,
            key: "#",
            to: "#",
            breadcrumbname: "Configurations",
            children: [
              {
                label: <Link to="/digitalization/machine-maintenance/configurations/brand">Brand</Link>,
                key: "/digitalization/machine-maintenance/configurations/brand",
                to: "/digitalization/machine-maintenance/configurations/brand",
                breadcrumbname: "Brand",
                allowedpermissions: [MACHINE_BRAND_VIEW_PERMISSION],
              },
              {
                label: <Link to="/digitalization/machine-maintenance/configurations/company">Company</Link>,
                key: "/digitalization/machine-maintenance/configurations/company",
                to: "/digitalization/machine-maintenance/configurations/company",
                breadcrumbname: "Company",
                allowedpermissions: [MACHINE_COMPANY_VIEW_PERMISSION],
              },
              {
                label: <Link to="/digitalization/machine-maintenance/configurations/model">Model</Link>,
                key: "/digitalization/machine-maintenance/configurations/model",
                to: "/digitalization/machine-maintenance/configurations/model",
                breadcrumbname: "Model",
                allowedpermissions: [MACHINE_MODEL_VIEW_PERMISSION],
              },
              {
                label: <Link to="/digitalization/machine-maintenance/configurations/location">Location</Link>,
                key: "/digitalization/machine-maintenance/configurations/location",
                to: "/digitalization/machine-maintenance/configurations/location",
                breadcrumbname: "Location",
                allowedpermissions: [MACHINE_LOCATION_VIEW_PERMISSION],
              },
              {
                label: <Link to="/digitalization/machine-maintenance/configurations/machine-line">Machine Line</Link>,
                key: "/digitalization/machine-maintenance/configurations/machine-line",
                to: "/digitalization/machine-maintenance/configurations/machine-line",
                breadcrumbname: "machine-line",
                allowedpermissions: [MACHINE_MACHINE_LINE_VIEW_PERMISSION],
              },
              {
                label: (
                  <Link to="/digitalization/machine-maintenance/configurations/machine-origin-country">
                    Origin Country
                  </Link>
                ),
                key: "/digitalization/machine-maintenance/configurations/machine-origin-country",
                to: "/digitalization/machine-maintenance/configurations/machine-origin-country",
                breadcrumbname: "machine-origin-country",
                allowedpermissions: [MACHINE_ORIGIN_COUNTRY_VIEW_PERMISSION],
              },
              {
                label: (
                  <Link to="/digitalization/machine-maintenance/configurations/machine-action-type">Action Type</Link>
                ),
                key: "/digitalization/machine-maintenance/configurations/machine-action-type",
                to: "/digitalization/machine-maintenance/configurations/machine-action-type",
                breadcrumbname: "machine-action-type",
                allowedpermissions: [MACHINE_ACTION_TYPE_VIEW_PERMISSION],
              },
              {
                label: (
                  <Link to="/digitalization/machine-maintenance/configurations/machine-fault-type">Fault Type</Link>
                ),
                key: "/digitalization/machine-maintenance/configurations/machine-fault-type",
                to: "/digitalization/machine-maintenance/configurations/machine-fault-type",
                breadcrumbname: "machine-fault-type",
                allowedpermissions: [MACHINE_FAULT_TYPE_VIEW_PERMISSION],
              },
            ],
            allowedpermissions: [
              MACHINE_INFORMATION_VIEW_PERMISSION,
              MACHINE_BRAND_VIEW_PERMISSION,
              MACHINE_MODEL_VIEW_PERMISSION,
              MACHINE_LOCATION_VIEW_PERMISSION,
              MACHINE_MACHINE_LINE_VIEW_PERMISSION,
              MACHINE_ORIGIN_COUNTRY_VIEW_PERMISSION,
              MACHINE_ACTION_TYPE_VIEW_PERMISSION,
              MACHINE_FAULT_TYPE_VIEW_PERMISSION,
            ],
          },
          {
            label: <Link to="/digitalization/configurations/machine-information">Machine Information</Link>,
            key: "/digitalization/configurations/machine-information",
            to: "/digitalization/configurations/machine-information",
            breadcrumbname: "Machine Information",
            allowedpermissions: [
              MACHINE_INFORMATION_VIEW_PERMISSION,
              MACHINE_INFORMATION_STORE_PERMISSION,
              MACHINE_INFORMATION_UPDATE_PERMISSION,
              MACHINE_INFORMATION_DELETE_PERMISSION,
              MACHINE_INFORMATION_IMPORT_PERMISSION,
            ],
          },
          {
            label: <Link to="/digitalization/machine-maintenance/mechanics">Mechanics</Link>,
            key: "/digitalization/machine-maintenance/mechanics",
            to: "/digitalization/machine-maintenance/mechanics",
            breadcrumbname: "Mechanics",
            allowedpermissions: [MACHINE_LINE_ATTENDANCE_MECHANIC_LIST_PERMISSION],
          },
          {
            label: <Link to="/digitalization/machine-maintenance/machine-issues">Machine Issues</Link>,
            key: "/digitalization/machine-maintenance/machine-issues",
            to: "/digitalization/machine-maintenance/machine-issues",
            breadcrumbname: "Machine Issues",
            allowedpermissions: [MACHINE_LINE_ISSUES_VIEW_PERMISSION],
          },
        ],
      },
      {
        label: <Link to="/digitalization/hourly-operation-tracking">Hourly Operation Tracking</Link>,
        key: "/digitalization/hourly-operation-tracking",
        to: "/digitalization/hourly-operation-tracking",
        breadcrumbname: "Hourly Operation Tracking",
        allowedpermissions: [HOURLY_OPERATION_TRACKING_VIEW_PERMISSION],
      },
    ],
  },
  {
    icon: <ShopOutlined />,
    label: "Capacity Bookings",
    key: "/capacity-bookings",
    to: "/capacity-bookings",
    breadcrumbname: "Capacity Bookings",
    allowedpermissions: [CAPACITY_BOOKING_MENU_VIEW_PERMISSION],
    children: [
      {
        label: <Link to="/capacity-bookings/report">Report</Link>,
        key: "/capacity-bookings/report",
        to: "/capacity-bookings/report",
        breadcrumbname: "Capacity Bookings Report",
        allowedpermissions: [CAPACITY_BOOKING_MENU_VIEW_PERMISSION],
      },
      {
        label: <Link to="/capacity-bookings">Settings</Link>,
        key: "/capacity-bookings",
        to: "/capacity-bookings",
        breadcrumbname: "Capacity Bookings",
        allowedpermissions: [CAPACITY_BOOKING_MENU_VIEW_PERMISSION],
      },
    ],
  },
  // {
  //   icon: <ShopOutlined />,
  //   label: "ERP Usage",
  //   key: "erp-usage",
  //   to: "/erp-usage",
  //   breadcrumbname: "ERP Usage",
  //   allowedpermissions: [ERP_USAGE_MODULE_VIEW_PERMISSION],
  //   children: [
  //     {
  //       label: <Link to="/erp-usage/dashboard">Dashboard</Link>,
  //       key: "/erp-usage/dashboard",
  //       to: "/erp-usage/dashboard",
  //       breadcrumbname: "ERP Usage Dashboard",
  //       allowedpermissions: [ERP_USAGE_MODULE_VIEW_PERMISSION],
  //     },
  //     {
  //       label: <Link to="/erp-usage/modules">Modules</Link>,
  //       key: "/erp-usage/modules",
  //       to: "/erp-usage/modules",
  //       breadcrumbname: "ERP Usage Modules",
  //       allowedpermissions: [ERP_USAGE_MODULE_VIEW_PERMISSION],
  //     },
  //     {
  //       label: <Link to="/erp-usage/module-uis">UIs</Link>,
  //       key: "/erp-usage/module-uis",
  //       to: "/erp-usage/module-uis",
  //       breadcrumbname: "ERP Usage Module UIs",
  //       allowedpermissions: [ERP_USAGE_MODULE_VIEW_PERMISSION],
  //     },
  //     {
  //       label: <Link to="/erp-usage/issues">Issues</Link>,
  //       key: "/erp-usage/issues",
  //       to: "/erp-usage/issues",
  //       breadcrumbname: "ERP Usage Issues",
  //       allowedpermissions: [ERP_USAGE_MODULE_VIEW_PERMISSION],
  //     },
  //   ],
  // },
  {
    icon: <ShopOutlined />,
    label: "PNL Report",
    key: "PNL Report",
    to: "/pnl-report",
    breadcrumbname: "PNL Report",
    allowedpermissions: [PNL_REPORT_VIEW_PERMISSION],
    children: [
      {
        label: <Link to="/pnl-report/dashboard">Dashboard</Link>,
        key: "/pnl-report/dashboard",
        to: "/pnl-report/dashboard",
        breadcrumbname: "Dashboard",
        allowedpermissions: [NO_PERMISSION_REQUIRED],
      },
      // {
      //   label: <Link to="/pnl-report/daily-sewing-performance">Daily Sewing Performance</Link>,
      //   key: "/pnl-report/daily-sewing-performance",
      //   to: "/pnl-report/daily-sewing-performance",
      //   breadcrumbname: "Daily Sewing Performance",
      //   allowedpermissions: [DAILY_SEWING_PERFORMANCE_VIEW_PERMISSION],
      // },
      {
        label: <Link to="/pnl-report/he-ot-expense-data">HR OT Expense Data</Link>,
        key: "/pnl-report/he-ot-expense-data",
        to: "/pnl-report/he-ot-expense-data",
        breadcrumbname: "HR OT Expense Data",
        allowedpermissions: [HR_OT_EXPENSE_DATA_IMPORT_PERMISSION],
      },
      {
        label: <Link to="/pnl-report/line-wise-sewing-report">Line Wise Sewing Report</Link>,
        key: "/pnl-report/line-wise-sewing-report",
        to: "/pnl-report/line-wise-sewing-report",
        breadcrumbname: "Line Wise Sewing Report",
        allowedpermissions: [LINE_WISE_SEWING_REPORT_VIEW_PERMISSION],
      },
      {
        label: <Link to="/pnl-report/ipr-mmd">Individual Performance Report</Link>,
        key: "/pnl-report/ipr-mmd",
        to: "/pnl-report/ipr-mmd",
        breadcrumbname: "Individual Performance Report",
        allowedpermissions: [IPR_REPORT_VIEW_PERMISSION],
      },
      {
        label: <Link to="/pnl-report/efficiency">Efficiency</Link>,
        key: "/pnl-report/efficiency",
        to: "/pnl-report/efficiency",
        breadcrumbname: "efficiency",
        allowedpermissions: [NO_PERMISSION_REQUIRED],
      },
      {
        label: <Link to="/pnl-report/target-vs-achievement">Target Vs Achievement</Link>,
        key: "/pnl-report/target-vs-achievement",
        to: "/pnl-report/target-vs-achievement",
        breadcrumbname: "Target Vs Achievement",
        allowedpermissions: [NO_PERMISSION_REQUIRED],
      },
      {
        label: <Link to="/pnl-report/cpm">CPM</Link>,
        key: "/pnl-report/cpm",
        to: "/pnl-report/cpm",
        breadcrumbname: "CPM",
        allowedpermissions: [NO_PERMISSION_REQUIRED],
      },
      {
        label: <Link to="/pnl-report/daily-profit-loss-summary">Profit & Loss Summary</Link>,
        key: "/pnl-report/daily-profit-loss-summary",
        to: "/pnl-report/daily-profit-loss-summary",
        breadcrumbname: "Daily Profit & Loss Summary",
        allowedpermissions: [NO_PERMISSION_REQUIRED],
      },
      {
        label: <Link to="/pnl-report/profit-loss-account">Profit & Loss Account</Link>,
        key: "/pnl-report/profit-loss-account",
        to: "/pnl-report/profit-loss-account",
        breadcrumbname: "Daily Profit & Loss Account",
        allowedpermissions: [NO_PERMISSION_REQUIRED],
      },
      {
        label: <Link to="/performance/performance-folding">Profit & Loss Statement</Link>,
        key: "/performance/performance-folding",
        to: "/performance/performance-folding",
        breadcrumbname: "Profit & Loss Statement",
        allowedpermissions: [NO_PERMISSION_REQUIRED],
      },
    ],
  },
  {
    icon: <DeliveredProcedureOutlined />,
    label: "Import Export Expense Tracking",
    key: "import-export-expense-tracking",
    allowedpermissions: [IMPORT_EXPORT_EXPENSE_TRACKING_VIEW_PERMISSION],
    children: [
      // {
      //   label: (
      //     <Link to={"/import-export-expense-tracking/export-invoice-expense"}>
      //       Export Invoice Expense
      //     </Link>
      //   ),
      //   key: "/import-export-expense-tracking/export-invoice-expense",
      //   to: "/export-invoice-expense",
      //   allowedpermissions: [
      //     EXPORT_INVOICE_EXPENSE_TRACKER_VIEW_PERMISSION,
      //     EXPORT_INVOICE_EXPENSE_TRACKER_EDIT_PERMISSION,
      //     EXPORT_INVOICE_EXPENSE_TRACKER_CREATE_PERMISSION,
      //     EXPORT_INVOICE_EXPENSE_TRACKER_DELETE_PERMISSION,
      //   ],
      // },
      // {
      //   label: (
      //     <Link to={"/import-export-expense-tracking/sales-contract-expense"}>
      //       Export Sales Contract Expense
      //     </Link>
      //   ),
      //   key: "/import-export-expense-tracking/sales-contract-expense",
      //   to: "/sales-contract-expense",
      //   allowedpermissions: [
      //     EXPORT_SALES_CONTRACT_EXPENSE_TRACKER_VIEW_PERMISSION,
      //     EXPORT_SALES_CONTRACT_EXPENSE_TRACKER_EDIT_PERMISSION,
      //     EXPORT_SALES_CONTRACT_EXPENSE_TRACKER_CREATE_PERMISSION,
      //     EXPORT_SALES_CONTRACT_EXPENSE_TRACKER_DELETE_PERMISSION,
      //   ],
      // },
      // {
      //   label: (
      //     <Link to={"/import-export-expense-tracking/import-invoice-expense"}>
      //       Import Invoice Expense
      //     </Link>
      //   ),
      //   key: "/import-export-expense-tracking/import-invoice-expense",
      //   to: "/import-invoice-expense",
      //   allowedpermissions: [
      //     IMPORT_INVOICE_EXPENSE_TRACKER_VIEW_PERMISSION,
      //     IMPORT_INVOICE_EXPENSE_TRACKER_EDIT_PERMISSION,
      //     IMPORT_INVOICE_EXPENSE_TRACKER_CREATE_PERMISSION,
      //     IMPORT_INVOICE_EXPENSE_TRACKER_DELETE_PERMISSION,
      //   ],
      // },
      // {
      //   label: (
      //     <Link to={"/import-export-expense-tracking/import-lc-expense"}>
      //       Import LC Expense
      //     </Link>
      //   ),
      //   key: "/import-export-expense-tracking/import-lc-expense",
      //   to: "/import-lc-expense",
      //   allowedpermissions: [
      //     IMPORT_LC_EXPENSE_TRACKER_VIEW_PERMISSION,
      //     IMPORT_LC_EXPENSE_TRACKER_EDIT_PERMISSION,
      //     IMPORT_LC_EXPENSE_TRACKER_CREATE_PERMISSION,
      //     IMPORT_LC_EXPENSE_TRACKER_DELETE_PERMISSION,
      //   ],
      // },
      // {
      //   label: (
      //     <Link to={"/import-export-expense-tracking/import-details"}>
      //       Import Details
      //     </Link>
      //   ),
      //   key: "/import-export-expense-tracking/import-details",
      //   to: "/import-details",
      //   allowedpermissions: [NO_PERMISSION_REQUIRED],
      // },
      // {
      //   label: (
      //     <Link to={"/import-export-expense-tracking/export-and-summary"}>
      //       Export & Summary
      //     </Link>
      //   ),
      //   key: "/import-export-expense-tracking/export-and-summary",
      //   to: "/export-and-summary",
      //   allowedpermissions: [NO_PERMISSION_REQUIRED],
      // },

      {
        label: "Configure",
        key: "/import-export-expense-tracking/configure",
        to: "/import-export-expense-tracking/configure",
        breadcrumbname: "Configure",
        allowedpermissions: [
          EXIM_CONFIGURE_VIEW_PERMISSION,
          EXIM_CONFIGURE_CREATE_PERMISSION,
          EXIM_CONFIGURE_EDIT_PERMISSION,
          EXIM_CONFIGURE_DELETE_PERMISSION,
        ],
        children: [
          {
            label: <Link to="/import-export-expense-tracking/configure/cost-head">Cost Head</Link>,
            key: "/import-export-expense-tracking/configure/cost-head",
            to: "/import-export-expense-tracking/configure/cost-head",
            breadcrumbname: "Cost Head",
            allowedpermissions: [
              EXIM_CONFIGURE_VIEW_PERMISSION,
              EXIM_CONFIGURE_CREATE_PERMISSION,
              EXIM_CONFIGURE_EDIT_PERMISSION,
              EXIM_CONFIGURE_DELETE_PERMISSION,
            ],
          },
          {
            label: <Link to="/import-export-expense-tracking/configure/cost-type">Cost Type</Link>,
            key: "/import-export-expense-tracking/configure/cost-type",
            to: "/import-export-expense-tracking/configure/cost-type",
            breadcrumbname: "Cost Type",
            allowedpermissions: [
              EXIM_CONFIGURE_VIEW_PERMISSION,
              EXIM_CONFIGURE_CREATE_PERMISSION,
              EXIM_CONFIGURE_EDIT_PERMISSION,
              EXIM_CONFIGURE_DELETE_PERMISSION,
            ],
          },
          {
            label: <Link to="/import-export-expense-tracking/configure/exim-accounts">Exim Accounts</Link>,
            key: "/import-export-expense-tracking/configure/exim-accounts",
            to: "/import-export-expense-tracking/configure/exim-accounts",
            breadcrumbname: "Exim Accounts",
            allowedpermissions: [
              EXIM_CONFIGURE_VIEW_PERMISSION,
              EXIM_CONFIGURE_CREATE_PERMISSION,
              EXIM_CONFIGURE_EDIT_PERMISSION,
              EXIM_CONFIGURE_DELETE_PERMISSION,
            ],
          },
          {
            label: <Link to="/import-export-expense-tracking/configure/charges">Charges</Link>,
            key: "/import-export-expense-tracking/configure/charges",
            to: "/import-export-expense-tracking/configure/charges",
            breadcrumbname: "Charges",
            allowedpermissions: [
              EXIM_CONFIGURE_VIEW_PERMISSION,
              EXIM_CONFIGURE_CREATE_PERMISSION,
              EXIM_CONFIGURE_EDIT_PERMISSION,
              EXIM_CONFIGURE_DELETE_PERMISSION,
            ],
          },
          {
            label: "C&F Settings",
            key: "/import-export-expense-tracking/configure/cnf-settings",
            breadcrumbname: "C&F Settings",
            allowedpermissions: [
              EXIM_CONFIGURE_VIEW_PERMISSION,
              EXIM_CONFIGURE_CREATE_PERMISSION,
              EXIM_CONFIGURE_EDIT_PERMISSION,
              EXIM_CONFIGURE_DELETE_PERMISSION,
            ],
            children: [
              {
                label: <Link to="/import-export-expense-tracking/configure/cnf-settings/import-cnf">Import C&F</Link>,
                key: "/import-export-expense-tracking/configure/cnf-settings/import-cnf",
                to: "/import-export-expense-tracking/configure/cnf-settings/import-cnf",
                breadcrumbname: "Import C&F",
                allowedpermissions: [
                  EXIM_CONFIGURE_VIEW_PERMISSION,
                  EXIM_CONFIGURE_CREATE_PERMISSION,
                  EXIM_CONFIGURE_EDIT_PERMISSION,
                  EXIM_CONFIGURE_DELETE_PERMISSION,
                ],
              },
              {
                label: <Link to="/import-export-expense-tracking/configure/cnf-settings/export-cnf">Export C&F</Link>,
                key: "/import-export-expense-tracking/configure/cnf-settings/export-cnf",
                to: "/import-export-expense-tracking/configure/cnf-settings/export-cnf",
                breadcrumbname: "Export C&F",
                allowedpermissions: [
                  EXIM_CONFIGURE_VIEW_PERMISSION,
                  EXIM_CONFIGURE_CREATE_PERMISSION,
                  EXIM_CONFIGURE_EDIT_PERMISSION,
                  EXIM_CONFIGURE_DELETE_PERMISSION,
                ],
              },
            ],
          },
          {
            label: <Link to={"/import-export-expense-tracking/configure/epb-type"}>EPB Type</Link>,
            key: "/import-export-expense-tracking/configure/epb-type",
            to: "/import-export-expense-tracking/configure/epb-type",
            breadcrumbname: "EPB Type",
            allowedpermissions: [
              EPB_TYPE_VIEW_PERMISSION,
              EPB_TYPE_CREATE_PERMISSION,
              EPB_TYPE_EDIT_PERMISSION,
              EPB_TYPE_DELETE_PERMISSION,
            ],
          },
          {
            label: <Link to={"/import-export-expense-tracking/configure/epb-attribute"}>EPB Attribute</Link>,
            key: "/import-export-expense-tracking/configure/epb-attribute",
            to: "/import-export-expense-tracking/configure/epb-attribute",
            breadcrumbname: "EPB Attribute",
            allowedpermissions: [
              EPB_ATTRIBUTE_VIEW_PERMISSION,
              EPB_ATTRIBUTE_CREATE_PERMISSION,
              EPB_ATTRIBUTE_EDIT_PERMISSION,
              EPB_ATTRIBUTE_DELETE_PERMISSION,
            ],
          },
          {
            label: "Expenditure",
            key: "/import-export-expense-tracking/configure/expenditure",
            breadcrumbname: "Expenditure",
            // Add permissions as needed, or use [NO_PERMISSION_REQUIRED]
            allowedpermissions: [IMPORT_EXPORT_EXPENSE_TRACKING_VIEW_PERMISSION],
            children: [
              {
                label: <Link to="/import-export-expense-tracking/configure/expenditure/export-ra">Export RA</Link>,
                key: "/import-export-expense-tracking/configure/expenditure/export-ra",
                to: "/import-export-expense-tracking/configure/expenditure/export-ra",
                breadcrumbname: "Export RA",
                allowedpermissions: [IOU_EXPENDITURE_FOR_EXPORT],
              },
              {
                label: <Link to="/import-export-expense-tracking/configure/expenditure/export-nra">Export NRA</Link>,
                key: "/import-export-expense-tracking/configure/expenditure/export-nra",
                to: "/import-export-expense-tracking/configure/expenditure/export-nra",
                breadcrumbname: "Export NRA",
                allowedpermissions: [IOU_EXPENDITURE_FOR_EXPORT],
              },
              {
                label: <Link to="/import-export-expense-tracking/configure/expenditure/import-ra">Import RA</Link>,
                key: "/import-export-expense-tracking/configure/expenditure/import-ra",
                to: "/import-export-expense-tracking/configure/expenditure/import-ra",
                breadcrumbname: "Import RA",
                allowedpermissions: [IOU_EXPENDITURE_FOR_IMPORT],
              },
              {
                label: <Link to="/import-export-expense-tracking/configure/expenditure/import-nra">Import NRA</Link>,
                key: "/import-export-expense-tracking/configure/expenditure/import-nra",
                to: "/import-export-expense-tracking/configure/expenditure/import-nra",
                breadcrumbname: "Import NRA",
                allowedpermissions: [IOU_EXPENDITURE_FOR_IMPORT],
              },
            ],
          },
        ],
      },
      {
        label: "External C&F Bills",
        key: "/import-export-expense-tracking/external-cnf-bills",
        breadcrumbname: "External C&F Bills",
        allowedpermissions: [
          EXTERNAL_CNF_BILLS_VIEW_PERMISSION,
          EXTERNAL_CNF_BILLS_CREATE_PERMISSION,
          EXTERNAL_CNF_BILLS_EDIT_PERMISSION,
          EXTERNAL_CNF_BILLS_DELETE_PERMISSION,
        ],
        children: [
          {
            label: <Link to="/import-export-expense-tracking/external-cnf-bills/import-cnf-bill">Import C&F bill</Link>,
            key: "/import-export-expense-tracking/external-cnf-bills/import-cnf-bill",
            to: "/import-export-expense-tracking/external-cnf-bills/import-cnf-bill",
            breadcrumbname: "Import C&F bill",
            allowedpermissions: [
              EXTERNAL_CNF_BILLS_VIEW_PERMISSION,
              EXTERNAL_CNF_BILLS_CREATE_PERMISSION,
              EXTERNAL_CNF_BILLS_EDIT_PERMISSION,
              EXTERNAL_CNF_BILLS_DELETE_PERMISSION,
            ],
          },
          {
            label: <Link to="/import-export-expense-tracking/external-cnf-bills/export-cnf-bill">Export C&F bill</Link>,
            key: "/import-export-expense-tracking/external-cnf-bills/export-cnf-bill",
            to: "/import-export-expense-tracking/external-cnf-bills/export-cnf-bill",
            breadcrumbname: "Export C&F bill",
            allowedpermissions: [
              EXTERNAL_CNF_BILLS_VIEW_PERMISSION,
              EXTERNAL_CNF_BILLS_CREATE_PERMISSION,
              EXTERNAL_CNF_BILLS_EDIT_PERMISSION,
              EXTERNAL_CNF_BILLS_DELETE_PERMISSION,
            ],
          },
          {
            label: (
              <Link to="/import-export-expense-tracking/external-cnf-bills/prepare-billing">
                Prepare billing
              </Link>
            ),
            key: "/import-export-expense-tracking/external-cnf-bills/prepare-billing",
            to: "/import-export-expense-tracking/external-cnf-bills/prepare-billing",
            breadcrumbname: "Prepare billing",
            allowedpermissions: [
              EXTERNAL_CNF_BILLS_VIEW_PERMISSION,
              EXTERNAL_CNF_BILLS_CREATE_PERMISSION,
              EXTERNAL_CNF_BILLS_EDIT_PERMISSION,
              EXTERNAL_CNF_BILLS_DELETE_PERMISSION,
            ],
          },
        ],
      },
      // Sales Contract menu removed - Lien costs moved to Banking Cost
      {
        label: "BGMEA Cost",
        key: "/import-export-expense-tracking/bgmea-cost",
        to: "/import-export-expense-tracking/bgmea-cost",
        breadcrumbname: "BGMEA Cost",
        allowedpermissions: [NO_PERMISSION_REQUIRED],
        children: [
          {
            label: <Link to="/import-export-expense-tracking/bgmea-ud-cost">BGMEA UD Cost</Link>,
            key: "/import-export-expense-tracking/bgmea-ud-cost",
            to: "/import-export-expense-tracking/bgmea-ud-cost",
            breadcrumbname: "BGMEA UD Cost",
            allowedpermissions: [
              BGMEA_UD_COST_VIEW_PERMISSION,
              BGMEA_UD_COST_CREATE_PERMISSION,
              BGMEA_UD_COST_EDIT_PERMISSION,
              BGMEA_UD_COST_DELETE_PERMISSION,
            ],
          },
          {
            label: <Link to="/import-export-expense-tracking/bgmea-ud-amendment">BGMEA UD Amendment</Link>,
            key: "/import-export-expense-tracking/bgmea-ud-amendment",
            to: "/import-export-expense-tracking/bgmea-ud-amendment",
            breadcrumbname: "BGMEA UD Amendment",
            allowedpermissions: [
              BGMEA_UD_AMENDMENT_VIEW_PERMISSION,
              BGMEA_UD_AMENDMENT_CREATE_PERMISSION,
              BGMEA_UD_AMENDMENT_EDIT_PERMISSION,
              BGMEA_UD_AMENDMENT_DELETE_PERMISSION,
            ],
          },
          {
            label: (
              <Link to="/import-export-expense-tracking/bgmea-ud-export-permission-cost">
                BGMEA UD Export Permission Cost
              </Link>
            ),
            key: "/import-export-expense-tracking/bgmea-ud-export-permission-cost",
            to: "/import-export-expense-tracking/bgmea-ud-export-permission-cost",
            breadcrumbname: "BGMEA UD Export Permission Cost",
            allowedpermissions: [
              BGMEA_UD_EXPORT_PERMISSION_COST_VIEW_PERMISSION,
              BGMEA_UD_EXPORT_PERMISSION_COST_CREATE_PERMISSION,
              BGMEA_UD_EXPORT_PERMISSION_COST_EDIT_PERMISSION,
              BGMEA_UD_EXPORT_PERMISSION_COST_DELETE_PERMISSION,
            ],
          },
        ],
      },
      {
        label: "Banking Cost",
        key: "/import-export-expense-tracking/banking-cost",
        to: "/import-export-expense-tracking/banking-cost",
        breadcrumbname: "Banking Cost",
        allowedpermissions: [NO_PERMISSION_REQUIRED],
        children: [
          {
            label: <Link to="/import-export-expense-tracking/lien-cost">Sales Contract Lien Cost</Link>,
            key: "/import-export-expense-tracking/lien-cost",
            to: "/import-export-expense-tracking/lien-cost",
            breadcrumbname: "Lien Cost",
            allowedpermissions: [
              SALES_CONTRACT_LIEN_COST_VIEW_PERMISSION,
              SALES_CONTRACT_LIEN_COST_CREATE_PERMISSION,
              SALES_CONTRACT_LIEN_COST_EDIT_PERMISSION,
              SALES_CONTRACT_LIEN_COST_DELETE_PERMISSION,
            ],
          },
          {
            label: (
              <Link to="/import-export-expense-tracking/amendment-lien-cost">Sales Contract Amendment Lien Cost</Link>
            ),
            key: "/import-export-expense-tracking/amendment-lien-cost",
            to: "/import-export-expense-tracking/amendment-lien-cost",
            breadcrumbname: "Amendment Lien Cost",
            allowedpermissions: [
              SALES_CONTRACT_AMENDMENT_LIEN_COST_VIEW_PERMISSION,
              SALES_CONTRACT_AMENDMENT_LIEN_COST_CREATE_PERMISSION,
              SALES_CONTRACT_AMENDMENT_LIEN_COST_EDIT_PERMISSION,
              SALES_CONTRACT_AMENDMENT_LIEN_COST_DELETE_PERMISSION,
            ],
          },
          {
            label: <Link to="/import-export-expense-tracking/import-bill-retirement">Import Bill Retirement</Link>,
            key: "/import-export-expense-tracking/import-bill-retirement",
            to: "/import-export-expense-tracking/import-bill-retirement",
            breadcrumbname: "Import Bill Retirement",
            allowedpermissions: [
              IMPORT_BILL_RETIREMENT_VIEW_PERMISSION,
              IMPORT_BILL_RETIREMENT_CREATE_PERMISSION,
              IMPORT_BILL_RETIREMENT_EDIT_PERMISSION,
              IMPORT_BILL_RETIREMENT_DELETE_PERMISSION,
            ],
          },
          {
            label: <Link to="/import-export-expense-tracking/b2b-lc-opening-cost">B2B LC Opening Cost</Link>,
            key: "/import-export-expense-tracking/b2b-lc-opening-cost",
            to: "/import-export-expense-tracking/b2b-lc-opening-cost",
            breadcrumbname: "B2B LC Opening Cost",
            allowedpermissions: [
              B2B_LC_OPENING_COST_VIEW_PERMISSION,
              B2B_LC_OPENING_COST_CREATE_PERMISSION,
              B2B_LC_OPENING_COST_EDIT_PERMISSION,
              B2B_LC_OPENING_COST_DELETE_PERMISSION,
            ],
          },
          {
            label: (
              <Link to="/import-export-expense-tracking/b2b-lc-amendment-opening-cost">
                B2B LC Amendment Opening Cost
              </Link>
            ),
            key: "/import-export-expense-tracking/b2b-lc-amendment-opening-cost",
            to: "/import-export-expense-tracking/b2b-lc-amendment-opening-cost",
            breadcrumbname: "B2B LC Amendment Opening Cost",
            allowedpermissions: [
              B2B_LC_AMENDMENT_OPENING_COST_VIEW_PERMISSION,
              B2B_LC_AMENDMENT_OPENING_COST_CREATE_PERMISSION,
              B2B_LC_AMENDMENT_OPENING_COST_EDIT_PERMISSION,
              B2B_LC_AMENDMENT_OPENING_COST_DELETE_PERMISSION,
            ],
          },
          {
            label: (
              <Link to="/import-export-expense-tracking/b2b-lc-shipping-guarantee-cost">
                B2B LC Shipping Guarantee Cost
              </Link>
            ),
            key: "/import-export-expense-tracking/b2b-lc-shipping-guarantee-cost",
            to: "/import-export-expense-tracking/b2b-lc-shipping-guarantee-cost",
            breadcrumbname: "B2B LC Shipping Guarantee Cost",
            allowedpermissions: [
              B2B_LC_SHIPPING_GUARANTEE_COST_VIEW_PERMISSION,
              B2B_LC_SHIPPING_GUARANTEE_COST_CREATE_PERMISSION,
              B2B_LC_SHIPPING_GUARANTEE_COST_EDIT_PERMISSION,
              B2B_LC_SHIPPING_GUARANTEE_COST_DELETE_PERMISSION,
            ],
          },
          {
            label: (
              <Link to="/import-export-expense-tracking/b2b-lc-acceptance-commission">
                B2B LC Acceptance Commission
              </Link>
            ),
            key: "/import-export-expense-tracking/b2b-lc-acceptance-commission",
            to: "/import-export-expense-tracking/b2b-lc-acceptance-commission",
            breadcrumbname: "B2B LC Acceptance Commission",
            allowedpermissions: [
              B2B_LC_ACCEPTANCE_COMMISSION_VIEW_PERMISSION,
              B2B_LC_ACCEPTANCE_COMMISSION_CREATE_PERMISSION,
              B2B_LC_ACCEPTANCE_COMMISSION_EDIT_PERMISSION,
              B2B_LC_ACCEPTANCE_COMMISSION_DELETE_PERMISSION,
            ],
          },
          {
            label: <Link to="/import-export-expense-tracking/eb-collection-charge">EB Collection Charge</Link>,
            key: "/import-export-expense-tracking/eb-collection-charge",
            to: "/import-export-expense-tracking/eb-collection-charge",
            breadcrumbname: "EB Collection Charge",
            allowedpermissions: [
              EB_COLLECTION_CHARGE_VIEW_PERMISSION,
              EB_COLLECTION_CHARGE_CREATE_PERMISSION,
              EB_COLLECTION_CHARGE_EDIT_PERMISSION,
              EB_COLLECTION_CHARGE_DELETE_PERMISSION,
              EB_COLLECTION_CHARGE_PRINT_PERMISSION,
            ],
          },
        ],
      },
      {
        label: <Link to="/import-export-expense-tracking/iou-cost">IOU Cost</Link>,
        key: "/import-export-expense-tracking/iou-cost",
        to: "/import-export-expense-tracking/iou-cost",
        breadcrumbname: "IOU Cost",
        allowedpermissions: [IOU_DELETE_PERMISSION, IOU_EDIT_PERMISSION, IOU_CREATE_PERMISSION, IOU_VIEW_PERMISSION],
      },
      {
        label: <Link to="/import-export-expense-tracking/iou-disbursement">IOU Disbursement</Link>,
        key: "/import-export-expense-tracking/iou-disbursement",
        to: "/import-export-expense-tracking/iou-disbursement",
        breadcrumbname: "IOU Disbursement",
        allowedpermissions: [IOU_DISBURSE_PERMISSION],
      },
      // {
      //   label: <Link to="/import-export-expense-tracking/iou-documents-upload">IOU Adjustment</Link>,
      //   key: "/import-export-expense-tracking/iou-documents-upload",
      //   to: "/import-export-expense-tracking/iou-documents-upload",
      //   breadcrumbname: "IOU Adjustment",
      //   // TODO: permission missing
      //   allowedpermissions: [IOU_DISBURSE_PERMISSION],
      // },
      {
        label: <Link to="/import-export-expense-tracking/iou-adjustment-for-import">IOU Adjustment For Import</Link>,
        key: "/import-export-expense-tracking/iou-adjustment-for-import",
        to: "/import-export-expense-tracking/iou-adjustment-for-import",
        breadcrumbname: "IOU Adjustment For Import",
        allowedpermissions: [
          IOU_ADJUSTMENT_IMPORT_VIEW_PERMISSION,
          IOU_ADJUSTMENT_IMPORT_CREATE_PERMISSION,
          IOU_ADJUSTMENT_IMPORT_EDIT_PERMISSION,
          IOU_ADJUSTMENT_IMPORT_DELETE_PERMISSION,
          IOU_ADJUSTMENT_IMPORT_APPROVE_PERMISSION,
        ],
      },
      {
        label: <Link to="/import-export-expense-tracking/iou-adjustment-for-export">IOU Adjustment For Export</Link>,
        key: "/import-export-expense-tracking/iou-adjustment-for-export",
        to: "/import-export-expense-tracking/iou-adjustment-for-export",
        breadcrumbname: "IOU Adjustment For Export",
        allowedpermissions: [
          IOU_ADJUSTMENT_EXPORT_VIEW_PERMISSION,
          IOU_ADJUSTMENT_EXPORT_CREATE_PERMISSION,
          IOU_ADJUSTMENT_EXPORT_EDIT_PERMISSION,
          IOU_ADJUSTMENT_EXPORT_DELETE_PERMISSION,
          IOU_ADJUSTMENT_EXPORT_APPROVE_PERMISSION,
        ],
      },
      {
        label: <Link to="/import-export-expense-tracking/iou-adjustment-for-general">IOU Adjustment For General</Link>,
        key: "/import-export-expense-tracking/iou-adjustment-for-general",
        to: "/import-export-expense-tracking/iou-adjustment-for-general",
        breadcrumbname: "IOU Adjustment For General",
        allowedpermissions: [
          IOU_ADJUSTMENT_GENERAL_VIEW_PERMISSION,
          IOU_ADJUSTMENT_GENERAL_CREATE_PERMISSION,
          IOU_ADJUSTMENT_GENERAL_EDIT_PERMISSION,
          IOU_ADJUSTMENT_GENERAL_DELETE_PERMISSION,
          IOU_ADJUSTMENT_GENERAL_APPROVE_PERMISSION,
        ],
      },
      {
        label: <Link to="/import-export-expense-tracking/iou-documents-upload">IOU Documents Upload</Link>,
        key: "/import-export-expense-tracking/iou-documents-upload",
        to: "/import-export-expense-tracking/iou-documents-upload",
        breadcrumbname: "IOU Documents Upload",
        allowedpermissions: [IOU_DISBURSE_PERMISSION],
      },
      // {
      //   label: <Link to="/import-export-expense-tracking/export-doc-fee">Export Documentation Fee</Link>,
      //   key: "/import-export-expense-tracking/export-doc-fee",
      //   to: "/import-export-expense-tracking/export-doc-fee",
      //   breadcrumbname: "Export Documentation Fee",
      //   allowedpermissions: [
      //     EXPORT_DOC_FEE_VIEW_PERMISSION,
      //     EXPORT_DOC_FEE_CREATE_PERMISSION,
      //     EXPORT_DOC_FEE_EDIT_PERMISSION,
      //     EXPORT_DOC_FEE_DELETE_PERMISSION,
      //   ],
      // },
      // Certificate of Origin Fee
      {
        label: <Link to="/import-export-expense-tracking/certificate-of-origin-fee">Certificate of Origin Fee</Link>,
        key: "/import-export-expense-tracking/certificate-of-origin-fee",
        to: "/import-export-expense-tracking/certificate-of-origin-fee",
        breadcrumbname: "Certificate of Origin Fee",
        allowedpermissions: [
          CERTIFICATE_OF_ORIGIN_FEE_VIEW_PERMISSION,
          CERTIFICATE_OF_ORIGIN_FEE_CREATE_PERMISSION,
          CERTIFICATE_OF_ORIGIN_FEE_EDIT_PERMISSION,
          CERTIFICATE_OF_ORIGIN_FEE_DELETE_PERMISSION,
        ],
      },
      // Import Bill Retirement moved to Banking Cost menu
      // Marine Cover Note Bill Permission
      {
        label: <Link to="/import-export-expense-tracking/marine-cover-note-bill">Marine Cover Note Bill</Link>,
        key: "/import-export-expense-tracking/marine-cover-note-bill",
        to: "/import-export-expense-tracking/marine-cover-note-bill",
        breadcrumbname: "Marine Cover Note Bill",
        allowedpermissions: [
          MARINA_COVER_NOTE_BILL_VIEW_PERMISSION,
          MARINA_COVER_NOTE_BILL_CREATE_PERMISSION,
          MARINA_COVER_NOTE_BILL_EDIT_PERMISSION,
          MARINA_COVER_NOTE_BILL_DELETE_PERMISSION,
        ],
      },
    ],
  },
  {
    icon: <CarOutlined />,
    label: "Transportation Cost",
    key: "transportation-cost",
    allowedpermissions: [TRANSPORTATION_COST_VIEW_PERMISSION],
    children: [
      {
        label: "Config",
        key: "/transportation-cost/config",
        breadcrumbname: "Config",
        allowedpermissions: [
          TRANSPORTATION_COST_CONFIG_VIEW_PERMISSION,
          TRANSPORTATION_COST_CONFIG_CREATE_PERMISSION,
          TRANSPORTATION_COST_CONFIG_EDIT_PERMISSION,
          TRANSPORTATION_COST_CONFIG_DELETE_PERMISSION,
        ],
        children: [
          {
            label: <Link to="/transportation-cost/config/particular-rate">Particular & Rate</Link>,
            key: "/transportation-cost/config/particular-rate",
            to: "/transportation-cost/config/particular-rate",
            breadcrumbname: "Particular & Rate",
            allowedpermissions: [
              TRANSPORTATION_COST_CONFIG_VIEW_PERMISSION,
              TRANSPORTATION_COST_CONFIG_CREATE_PERMISSION,
              TRANSPORTATION_COST_CONFIG_EDIT_PERMISSION,
              TRANSPORTATION_COST_CONFIG_DELETE_PERMISSION,
            ],
          },
          {
            label: <Link to="/transportation-cost/config/charge-type">Charge Type & Amount</Link>,
            key: "/transportation-cost/config/charge-type",
            to: "/transportation-cost/config/charge-type",
            breadcrumbname: "Charge Type & Amount",
            allowedpermissions: [
              TRANSPORTATION_COST_CONFIG_VIEW_PERMISSION,
              TRANSPORTATION_COST_CONFIG_CREATE_PERMISSION,
              TRANSPORTATION_COST_CONFIG_EDIT_PERMISSION,
              TRANSPORTATION_COST_CONFIG_DELETE_PERMISSION,
            ],
          },
        ],
      },
      ...[
        { costType: "import", label: "Import" },
        { costType: "export", label: "Export" },
        { costType: "local", label: "Local" },
      ].map(({ costType, label }) => ({
        label: <Link to={`/transportation-cost/${costType}`}>{label}</Link>,
        key: `/transportation-cost/${costType}`,
        to: `/transportation-cost/${costType}`,
        breadcrumbname: label,
        allowedpermissions: [
          TRANSPORTATION_COST_ENTRY_VIEW_PERMISSION,
          TRANSPORTATION_COST_ENTRY_CREATE_PERMISSION,
          TRANSPORTATION_COST_ENTRY_EDIT_PERMISSION,
          TRANSPORTATION_COST_ENTRY_DELETE_PERMISSION,
          TRANSPORTATION_COST_ENTRY_PRINT_PERMISSION,
        ],
      })),
    ],
  },
];

// Tokens
const accessToken = localStorage.getItem("token");
const roleInfo = localStorage.getItem("roleInfo") && JSON.parse(localStorage.getItem("roleInfo"));
const assignedPermissions = roleInfo ? roleInfo?.permissions : null;

// Function to check if a menu item is allowed or not
const hasPermission = (allowedpermissions) => {
  const hasRolePermission =
    assignedPermissions &&
    assignedPermissions?.find((permissionItem) => allowedpermissions.includes(permissionItem?.name));

  // If has this page access
  if (accessToken && hasRolePermission) {
    return true;
  }

  // If the route does not require permissions
  if (accessToken && allowedpermissions.includes(NO_PERMISSION_REQUIRED)) {
    return true;
  }

  // // Else no access
  return false;
};

const filterMenuByPermissions = (menu, assignedPermissions) => {
  return menu.filter((item) => {
    if (item?.allowedpermissions && item?.allowedpermissions?.length > 0) {
      // Check if menu item is allowed
      const permissionAllowed = hasPermission(item.allowedpermissions);
      if (!permissionAllowed) {
        return false;
      }
    }

    // Recursive permission check on menu children items
    if (item.children) {
      item.children = filterMenuByPermissions(item.children, assignedPermissions);

      // Check if any child has permission
      if (item?.children?.length === 0) {
        // No child has permission, do not show the parent menu
        return false;
      }
    }

    // If a menu items comes this far, it is allowed
    return true;
  });
};

export const menu = filterMenuByPermissions(defaultMenuItems, assignedPermissions);
